<template>
        <div class="g-doc">
          <div class="table-of-contents"><ul><li><a href="#sdkmanager28sdku7ba1u7406u7c7b29">SdkManager(SDK管理类)</a><ul><li><a href="#addeventlistener0a3ca20id3daddeventlistener52843e203ca3e">addEventListener
<a id=addEventListener5284> </a></a></li><li><a href="#initsdk0a3ca20id3dinitsdk52843e203ca3e">initSdk
<a id=initSdk5284> </a></a></li><li><a href="#setserverip0a3ca20id3dsetserverip52843e203ca3e">setServerIp
<a id=setServerIp5284> </a></a></li><li><a href="#setclientidinfo0a3ca20id3dsetclientidinfo52843e203ca3e">setClientIdInfo
<a id=setClientIdInfo5284> </a></a></li><li><a href="#getaudiomanager0a3ca20id3dgetaudiomanager52843e203ca3e">getAudioManager
<a id=getAudioManager5284> </a></a></li><li><a href="#getchatmanager0a3ca20id3dgetchatmanager52843e203ca3e">getChatManager
<a id=getChatManager5284> </a></a></li><li><a href="#getloginmanager0a3ca20id3dgetloginmanager52843e203ca3e">getLoginManager
<a id=getLoginManager5284> </a></a></li><li><a href="#getmeetingmanager0a3ca20id3dgetmeetingmanager52843e203ca3e">getMeetingManager
<a id=getMeetingManager5284> </a></a></li><li><a href="#getsdkmanager0a3ca20id3dgetsdkmanager52843e203ca3e">getSdkManager
<a id=getSdkManager5284> </a></a></li><li><a href="#getscreensharemanager0a3ca20id3dgetscreensharemanager52843e203ca3e">getScreenShareManager
<a id=getScreenShareManager5284> </a></a></li><li><a href="#getusermanager0a3ca20id3dgetusermanager52843e203ca3e">getUserManager
<a id=getUserManager5284> </a></a></li><li><a href="#getvideomanager0a3ca20id3dgetvideomanager52843e203ca3e">getVideoManager
<a id=getVideoManager5284> </a></a></li><li><a href="#getsdkversion0a3ca20id3dgetsdkversion52843e203ca3e">getSdkVersion
<a id=getSdkVersion5284> </a></a></li><li><a href="#releasesdk0a3ca20id3dreleasesdk52843e203ca3e">releaseSdk
<a id=releaseSdk5284> </a></a></li></ul></li><li><a href="#loginmanager28u767bu5f55u7ba1u7406u7c7b29">LoginManager(登录管理类)</a><ul><li><a href="#addeventlistener0a3ca20id3daddeventlistener52883e203ca3e">addEventListener
<a id=addEventListener5288> </a></a></li><li><a href="#enterroom0a3ca20id3denterroom52883e203ca3e">enterRoom
<a id=enterRoom5288> </a></a></li><li><a href="#loginaccount0a3ca20id3dloginaccount52883e203ca3e">loginAccount
<a id=loginAccount5288> </a></a></li><li><a href="#loginroomid0a3ca20id3dloginroomid52883e203ca3e">loginRoomID
<a id=loginRoomID5288> </a></a></li><li><a href="#logout0a3ca20id3dlogout52883e203ca3e">logout
<a id=logout5288> </a></a></li><li><a href="#cancelenterroom0a3ca20id3dcancelenterroom52883e203ca3e">cancelEnterRoom
<a id=cancelEnterRoom5288> </a></a></li></ul></li><li><a href="#meetingmanager28u4f1au63a7u7ba1u7406u7c7b29">MeetingManager(会控管理类)</a><ul><li><a href="#addeventlistener0a3ca20id3daddeventlistener52923e203ca3e">addEventListener
<a id=addEventListener5292> </a></a></li><li><a href="#broadcastlayout0a3ca20id3dbroadcastlayout52923e203ca3e">broadcastLayout
<a id=broadcastLayout5292> </a></a></li><li><a href="#closemeeting0a3ca20id3dclosemeeting52923e203ca3e">closeMeeting
<a id=closeMeeting5292> </a></a></li><li><a href="#exitmeeting0a3ca20id3dexitmeeting52923e203ca3e">exitMeeting
<a id=exitMeeting5292> </a></a></li><li><a href="#getalloperateaudio0a3ca20id3dgetalloperateaudio52923e203ca3e">getAllOperateAudio
<a id=getAllOperateAudio5292> </a></a></li><li><a href="#getlocalrecordparam0a3ca20id3dgetlocalrecordparam52923e203ca3e">getLocalRecordParam
<a id=getLocalRecordParam5292> </a></a></li><li><a href="#getmeetinginfo0a3ca20id3dgetmeetinginfo52923e203ca3e">getMeetingInfo
<a id=getMeetingInfo5292> </a></a></li><li><a href="#isvoiceincentiveenable0a3ca20id3disvoiceincentiveenable52923e203ca3e">isVoiceIncentiveEnable
<a id=isVoiceIncentiveEnable5292> </a></a></li><li><a href="#pauselocalrecord0a3ca20id3dpauselocalrecord52923e203ca3e">pauseLocalRecord
<a id=pauseLocalRecord5292> </a></a></li><li><a href="#setlocalrecordparam0a3ca20id3dsetlocalrecordparam52923e203ca3e">setLocalRecordParam
<a id=setLocalRecordParam5292> </a></a></li><li><a href="#startlocalrecord0a3ca20id3dstartlocalrecord52923e203ca3e">startLocalRecord
<a id=startLocalRecord5292> </a></a></li><li><a href="#stoplocalrecord0a3ca20id3dstoplocalrecord52923e203ca3e">stopLocalRecord
<a id=stopLocalRecord5292> </a></a></li><li><a href="#setalloperateaudio0a3ca20id3dsetalloperateaudio52923e203ca3e">setAllOperateAudio
<a id=setAllOperateAudio5292> </a></a></li></ul></li><li><a href="#usermanager28u7528u6237u7ba1u7406u7c7b29">UserManager(用户管理类)</a><ul><li><a href="#abandonthemanager0a3ca20id3dabandonthemanager52963e203ca3e">abandonTheManager
<a id=abandonTheManager5296> </a></a></li><li><a href="#addeventlistener0a3ca20id3daddeventlistener52963e203ca3e">addEventListener
<a id=addEventListener5296> </a></a></li><li><a href="#agreeknockuser0a3ca20id3dagreeknockuser52963e203ca3e">agreeKnockUser
<a id=agreeKnockUser5296> </a></a></li><li><a href="#abandonthehost0a3ca20id3dabandonthehost52963e203ca3e">abandonTheHost
<a id=abandonTheHost5296> </a></a></li><li><a href="#agreetobehost0a3ca20id3dagreetobehost52963e203ca3e">agreeToBeHost
<a id=agreeToBeHost5296> </a></a></li><li><a href="#applytobehost0a3ca20id3dapplytobehost52963e203ca3e">applyToBeHost
<a id=applyToBeHost5296> </a></a></li><li><a href="#applytobemanager0a3ca20id3dapplytobemanager52963e203ca3e">applyToBeManager
<a id=applyToBeManager5296> </a></a></li><li><a href="#getallusers0a3ca20id3dgetallusers52963e203ca3e">getAllUsers
<a id=getAllUsers5296> </a></a></li><li><a href="#getcurrenthost0a3ca20id3dgetcurrenthost52963e203ca3e">getCurrentHost
<a id=getCurrentHost5296> </a></a></li><li><a href="#getlocaluser0a3ca20id3dgetlocaluser52963e203ca3e">getLocalUser
<a id=getLocalUser5296> </a></a></li><li><a href="#getuserinfo0a3ca20id3dgetuserinfo52963e203ca3e">getUserInfo
<a id=getUserInfo5296> </a></a></li><li><a href="#getonlineusercount0a3ca20id3dgetonlineusercount52963e203ca3e">getOnlineUserCount
<a id=getOnlineUserCount5296> </a></a></li><li><a href="#grantthehostforremoteuser0a3ca20id3dgrantthehostforremoteuser52963e203ca3e">grantTheHostForRemoteUser
<a id=grantTheHostForRemoteUser5296> </a></a></li><li><a href="#grantthemanagerforremoteuser0a3ca20id3dgrantthemanagerforremoteuser52963e203ca3e">grantTheManagerForRemoteUser
<a id=grantTheManagerForRemoteUser5296> </a></a></li><li><a href="#hashost0a3ca20id3dhashost52963e203ca3e">hasHost
<a id=hasHost5296> </a></a></li><li><a href="#kickuser0a3ca20id3dkickuser52963e203ca3e">kickUser
<a id=kickUser5296> </a></a></li><li><a href="#modifyusernickname0a3ca20id3dmodifyusernickname52963e203ca3e">modifyUserNickname
<a id=modifyUserNickname5296> </a></a></li></ul></li><li><a href="#videomanager28u89c6u9891u7ba1u7406u7c7b29">VideoManager(视频管理类)</a><ul><li><a href="#pausevideo0a3ca20id3dpausevideo53003e203ca3e">pauseVideo
<a id=pauseVideo5300> </a></a></li><li><a href="#startcheckvideoview0a3ca20id3dstartcheckvideoview53003e203ca3e">startCheckVideoView
<a id=startCheckVideoView5300> </a></a></li><li><a href="#stopcheckvideoview0a3ca20id3dstopcheckvideoview53003e203ca3e">stopCheckVideoView
<a id=stopCheckVideoView5300> </a></a></li><li><a href="#startlocalvideopreview0a3ca20id3dstartlocalvideopreview53003e203ca3e">startLocalVideoPreview
<a id=startLocalVideoPreview5300> </a></a></li><li><a href="#stoplocalvideopreview0a3ca20id3dstoplocalvideopreview53003e203ca3e">stopLocalVideoPreview
<a id=stopLocalVideoPreview5300> </a></a></li><li><a href="#agreeapplyvideo0a3ca20id3dagreeapplyvideo53003e203ca3e">agreeApplyVideo
<a id=agreeApplyVideo5300> </a></a></li><li><a href="#addeventlistener0a3ca20id3daddeventlistener53003e203ca3e">addEventListener
<a id=addEventListener5300> </a></a></li><li><a href="#broadcastvideo0a3ca20id3dbroadcastvideo53003e203ca3e">broadcastVideo
<a id=broadcastVideo5300> </a></a></li><li><a href="#applybroadcastvideo0a3ca20id3dapplybroadcastvideo53003e203ca3e">applyBroadcastVideo
<a id=applyBroadcastVideo5300> </a></a></li><li><a href="#setcameraenable0a3ca20id3dsetcameraenable53003e203ca3e">setCameraEnable
<a id=setCameraEnable5300> </a></a></li><li><a href="#getvideoparam0a3ca20id3dgetvideoparam53003e203ca3e">getVideoParam
<a id=getVideoParam5300> </a></a></li><li><a href="#setvideoparam0a3ca20id3dsetvideoparam53003e203ca3e">setVideoParam
<a id=setVideoParam5300> </a></a></li><li><a href="#getvideodevicelist0a3ca20id3dgetvideodevicelist53003e203ca3e">getVideoDeviceList
<a id=getVideoDeviceList5300> </a></a></li><li><a href="#iscameraenable0a3ca20id3discameraenable53003e203ca3e">isCameraEnable
<a id=isCameraEnable5300> </a></a></li><li><a href="#setdefaultvideodevice0a3ca20id3dsetdefaultvideodevice53003e203ca3e">setDefaultVideoDevice
<a id=setDefaultVideoDevice5300> </a></a></li><li><a href="#setdisplaymode0a3ca20id3dsetdisplaymode53003e203ca3e">setDisplayMode
<a id=setDisplayMode5300> </a></a></li></ul></li><li><a href="#audiomanager28u97f3u9891u7ba1u7406u7c7b29">AudioManager(音频管理类)</a><ul><li><a href="#addaudiocapturecallback0a3ca20id3daddaudiocapturecallback53043e203ca3e">addAudioCaptureCallback
<a id=addAudioCaptureCallback5304> </a></a></li><li><a href="#addeventlistener0a3ca20id3daddeventlistener53043e203ca3e">addEventListener
<a id=addEventListener5304> </a></a></li><li><a href="#removeaudiocapturecallback0a3ca20id3dremoveaudiocapturecallback53043e203ca3e">removeAudioCaptureCallback
<a id=removeAudioCaptureCallback5304> </a></a></li><li><a href="#agreeapplyaudio0a3ca20id3dagreeapplyaudio53043e203ca3e">agreeApplyAudio
<a id=agreeApplyAudio5304> </a></a></li><li><a href="#getaudioparam0a3ca20id3dgetaudioparam53043e203ca3e">getAudioParam
<a id=getAudioParam5304> </a></a></li><li><a href="#setaudioparam0a3ca20id3dsetaudioparam53043e203ca3e">setAudioParam
<a id=setAudioParam5304> </a></a></li><li><a href="#applybroadcastaudio0a3ca20id3dapplybroadcastaudio53043e203ca3e">applyBroadcastAudio
<a id=applyBroadcastAudio5304> </a></a></li><li><a href="#broadcastaudio0a3ca20id3dbroadcastaudio53043e203ca3e">broadcastAudio
<a id=broadcastAudio5304> </a></a></li><li><a href="#setallmute0a3ca20id3dsetallmute53043e203ca3e">setAllMute
<a id=setAllMute5304> </a></a></li><li><a href="#getspeakervolume0a3ca20id3dgetspeakervolume53043e203ca3e">getSpeakerVolume
<a id=getSpeakerVolume5304> </a></a></li><li><a href="#getmicrophonedevice0a3ca20id3dgetmicrophonedevice53043e203ca3e">getMicrophoneDevice
<a id=getMicrophoneDevice5304> </a></a></li><li><a href="#setspeakerdeviceenable0a3ca20id3dsetspeakerdeviceenable53043e203ca3e">setSpeakerDeviceEnable
<a id=setSpeakerDeviceEnable5304> </a></a></li><li><a href="#setmicrophoneenable0a3ca20id3dsetmicrophoneenable53043e203ca3e">setMicrophoneEnable
<a id=setMicrophoneEnable5304> </a></a></li><li><a href="#startplayaudio0a3ca20id3dstartplayaudio53043e203ca3e">startPlayAudio
<a id=startPlayAudio5304> </a></a></li><li><a href="#getspeakerdevicelist0a3ca20id3dgetspeakerdevicelist53043e203ca3e">getSpeakerDeviceList
<a id=getSpeakerDeviceList5304> </a></a></li><li><a href="#getmicrophonedevicelist0a3ca20id3dgetmicrophonedevicelist53043e203ca3e">getMicrophoneDeviceList
<a id=getMicrophoneDeviceList5304> </a></a></li><li><a href="#setspeakerdevice0a3ca20id3dsetspeakerdevice53043e203ca3e">setSpeakerDevice
<a id=setSpeakerDevice5304> </a></a></li><li><a href="#setmicrophonedevice0a3ca20id3dsetmicrophonedevice53043e203ca3e">setMicrophoneDevice
<a id=setMicrophoneDevice5304> </a></a></li><li><a href="#getspeakerdevice0a3ca20id3dgetspeakerdevice53043e203ca3e">getSpeakerDevice
<a id=getSpeakerDevice5304> </a></a></li><li><a href="#stopplayaudio0a3ca20id3dstopplayaudio53043e203ca3e">stopPlayAudio
<a id=stopPlayAudio5304> </a></a></li><li><a href="#setappmute0a3ca20id3dsetappmute53043e203ca3e">setAppMute
<a id=setAppMute5304> </a></a></li><li><a href="#ismicrophoneenable0a3ca20id3dismicrophoneenable53043e203ca3e">isMicrophoneEnable
<a id=isMicrophoneEnable5304> </a></a></li><li><a href="#getmicrophonevolume0a3ca20id3dgetmicrophonevolume53043e203ca3e">getMicrophoneVolume
<a id=getMicrophoneVolume5304> </a></a></li><li><a href="#getmicrophoneenergy0a3ca20id3dgetmicrophoneenergy53043e203ca3e">getMicrophoneEnergy
<a id=getMicrophoneEnergy5304> </a></a></li><li><a href="#getmicrophoneenergy0a3ca20id3dgetmicrophoneenergy53043e203ca3e">getMicrophoneEnergy
<a id=getMicrophoneEnergy5304> </a></a></li></ul></li><li><a href="#wbsharemanager28u767du677fu7ba1u7406u7c7b29">WBShareManager(白板管理类)</a><ul><li><a href="#activewb0a3ca20id3dactivewb53083e203ca3e">activeWB
<a id=activeWB5308> </a></a></li><li><a href="#addeventlistener0a3ca20id3daddeventlistener53083e203ca3e">addEventListener
<a id=addEventListener5308> </a></a></li><li><a href="#addwbpicture0a3ca20id3daddwbpicture53083e203ca3e">addWBPicture
<a id=addWBPicture5308> </a></a></li><li><a href="#getwbdrawobject0a3ca20id3dgetwbdrawobject53083e203ca3e">getWBDrawObject
<a id=getWBDrawObject5308> </a></a></li><li><a href="#getwboperate0a3ca20id3dgetwboperate53083e203ca3e">getWBOperate
<a id=getWBOperate5308> </a></a></li><li><a href="#getwbstyle0a3ca20id3dgetwbstyle53083e203ca3e">getWBStyle
<a id=getWBStyle5308> </a></a></li><li><a href="#getwbtype0a3ca20id3dgetwbtype53083e203ca3e">getWBType
<a id=getWBType5308> </a></a></li><li><a href="#savewbfile0a3ca20id3dsavewbfile53083e203ca3e">saveWBFile
<a id=saveWBFile5308> </a></a></li><li><a href="#setrotatewb0a3ca20id3dsetrotatewb53083e203ca3e">setRotateWB
<a id=setRotateWB5308> </a></a></li><li><a href="#setwbbkcolor0a3ca20id3dsetwbbkcolor53083e203ca3e">setWBBkColor
<a id=setWBBkColor5308> </a></a></li><li><a href="#setwbcurzoom0a3ca20id3dsetwbcurzoom53083e203ca3e">setWBCurZoom
<a id=setWBCurZoom5308> </a></a></li><li><a href="#setwbdrawobject0a3ca20id3dsetwbdrawobject53083e203ca3e">setWBDrawObject
<a id=setWBDrawObject5308> </a></a></li><li><a href="#setwboperate0a3ca20id3dsetwboperate53083e203ca3e">setWBOperate
<a id=setWBOperate5308> </a></a></li><li><a href="#setwbstyle0a3ca20id3dsetwbstyle53083e203ca3e">setWBStyle
<a id=setWBStyle5308> </a></a></li><li><a href="#startwbshare0a3ca20id3dstartwbshare53083e203ca3e">startWBShare
<a id=startWBShare5308> </a></a></li><li><a href="#stopwbshare0a3ca20id3dstopwbshare53083e203ca3e">stopWBShare
<a id=stopWBShare5308> </a></a></li><li><a href="#startremotewbshareview0a3ca20id3dstartremotewbshareview53083e203ca3e">startRemoteWBShareView
<a id=startRemoteWBShareView5308> </a></a></li></ul></li><li><a href="#screensharemanager28u5c4fu5e55u5171u4eabu7ba1u7406u7c7b29">ScreenShareManager(屏幕共享管理类)</a><ul><li><a href="#isscreensharing0a3ca20id3disscreensharing53123e203ca3e">isScreenSharing
<a id=isScreenSharing5312> </a></a></li><li><a href="#addeventlistener0a3ca20id3daddeventlistener53123e203ca3e">addEventListener
<a id=addEventListener5312> </a></a></li><li><a href="#startremotescreenshareview0a3ca20id3dstartremotescreenshareview53123e203ca3e">startRemoteScreenShareView
<a id=startRemoteScreenShareView5312> </a></a></li><li><a href="#stopremotescreenshareview0a3ca20id3dstopremotescreenshareview53123e203ca3e">stopRemoteScreenShareView
<a id=stopRemoteScreenShareView5312> </a></a></li><li><a href="#startscreenshare0a3ca20id3dstartscreenshare53123e203ca3e">startScreenShare
<a id=startScreenShare5312> </a></a></li><li><a href="#stopscreenshare0a3ca20id3dstopscreenshare53123e203ca3e">stopScreenShare
<a id=stopScreenShare5312> </a></a></li><li><a href="#setscreensharequalitybias0a3ca20id3dsetscreensharequalitybias53123e203ca3e">setScreenShareQualityBias
<a id=setScreenShareQualityBias5312> </a></a></li><li><a href="#setscreensharevoice0a3ca20id3dsetscreensharevoice53123e203ca3e">setScreenShareVoice
<a id=setScreenShareVoice5312> </a></a></li><li><a href="#updatescreensharewnd0a3ca20id3dupdatescreensharewnd53123e203ca3e">updateScreenShareWnd
<a id=updateScreenShareWnd5312> </a></a></li><li><a href="#ismultishareenable0a3ca20id3dismultishareenable53123e203ca3e">isMultiShareEnable
<a id=isMultiShareEnable5312> </a></a></li><li><a href="#setmultishareenable0a3ca20id3dsetmultishareenable53123e203ca3e">setMultiShareEnable
<a id=setMultiShareEnable5312> </a></a></li><li><a href="#getcurrentdatasharecount0a3ca20id3dgetcurrentdatasharecount53123e203ca3e">getCurrentDataShareCount
<a id=getCurrentDataShareCount5312> </a></a></li></ul></li><li><a href="#chatmanager28u804au5929u7ba1u7406u7c7b29">ChatManager(聊天管理类)</a><ul><li><a href="#addeventlistener0a3ca20id3daddeventlistener53163e203ca3e">addEventListener
<a id=addEventListener5316> </a></a></li><li><a href="#sendchatmessage0a3ca20id3dsendchatmessage53163e203ca3e">sendChatMessage
<a id=sendChatMessage5316> </a></a></li></ul></li><li><a href="#permissionmanager28u6743u9650u7ba1u7406u7c7b29">PermissionManager(权限管理类)</a><ul><li><a href="#configroompermission0a3ca20id3dconfigroompermission53203e203ca3e">configRoomPermission
<a id=configRoomPermission5320> </a></a></li><li><a href="#checkroompermission0a3ca20id3dcheckroompermission53203e203ca3e">checkRoomPermission
<a id=checkRoomPermission5320> </a></a></li><li><a href="#configuserpermission0a3ca20id3dconfiguserpermission53203e203ca3e">configUserPermission
<a id=configUserPermission5320> </a></a></li><li><a href="#checkuserpermission0a3ca20id3dcheckuserpermission53203e203ca3e">checkUserPermission
<a id=checkUserPermission5320> </a></a></li></ul></li><li><a href="#roomlistmanager28u4f1au8baeu5217u8868u7ba1u7406u7c7b29">RoomListManager(会议列表管理类)</a><ul><li><a href="#addeventlistener0a3ca20id3daddeventlistener53243e203ca3e">addEventListener
<a id=addEventListener5324> </a></a></li><li><a href="#querycommonmeeting0a3ca20id3dquerycommonmeeting53243e203ca3e">queryCommonMeeting
<a id=queryCommonMeeting5324> </a></a></li><li><a href="#queryschedulmeeting0a3ca20id3dqueryschedulmeeting53243e203ca3e">querySchedulMeeting
<a id=querySchedulMeeting5324> </a></a></li><li><a href="#queryinstantmeeting0a3ca20id3dqueryinstantmeeting53243e203ca3e">queryInstantMeeting
<a id=queryInstantMeeting5324> </a></a></li><li><a href="#createinstantmeeting0a3ca20id3dcreateinstantmeeting53243e203ca3e">createInstantMeeting
<a id=createInstantMeeting5324> </a></a></li></ul></li><li><a href="#contactmanager28u901au8bafu5f55u7ba1u7406u7c7b29">ContactManager(通讯录管理类)</a><ul><li><a href="#acceptinvite0a3ca20id3dacceptinvite53283e203ca3e">acceptInvite
<a id=acceptInvite5328> </a></a></li><li><a href="#inviteuser0a3ca20id3dinviteuser53283e203ca3e">inviteUser
<a id=inviteUser5328> </a></a></li><li><a href="#querydeptinfo0a3ca20id3dquerydeptinfo53283e203ca3e">queryDeptInfo
<a id=queryDeptInfo5328> </a></a></li><li><a href="#querydeptuser0a3ca20id3dquerydeptuser53283e203ca3e">queryDeptUser
<a id=queryDeptUser5328> </a></a></li></ul></li><li><a href="#u5173u952eu7c7bu578bu5b9au4e49">关键类型定义</a><ul><li><a href="#errcode0a3ca20id3derrcode53323e203ca3e">ErrCode
<a id=ErrCode5332> </a></a></li><li><a href="#roomuserinfo0a3ca20id3droomuserinfo53323e203ca3e">RoomUserInfo
<a id=RoomUserInfo5332> </a></a></li></ul></li></ul></div>
          <div id="right" class="content-right">
           <h1 class="curproject-name"> Windows 3.37.10.51 </h1> 
<h1 id="sdkmanager28sdku7ba1u7406u7c7b29">SdkManager(SDK管理类)</h1>
<p></p>
<h2 id="addeventlistener0a3ca20id3daddeventlistener52843e203ca3e">addEventListener
<a id=addEventListener5284> </a></h2>
<p></p>
<h3 id="">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_SDK_INIT
说明：SDK初始化完成事件，可以绑定登录事件
</code></pre>
<h3 id="-2">参数</h3>
<h3 id="-3">返回数据</h3>
<table>
  <thead class="ant-table-thead">
    <tr>
      <th key=name>名称</th><th key=type>类型</th><th key=required>是否必须</th><th key=default>默认值</th><th key=desc>备注</th><th key=sub>其他信息</th>
    </tr>
  </thead><tbody className="ant-table-tbody">
               </tbody>
              </table>
<h2 id="initsdk0a3ca20id3dinitsdk52843e203ca3e">initSdk
<a id=initSdk5284> </a></h2>
<p></p>
<h3 id="-4">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>负责创建并初始化

IUserManager
ILoginManager
IMeetingManager
IChatManager
IVideoManager
IAudioManager
IScreenShareManager
IPermissionManager

另外 SdkManager 为单例模式
</code></pre>
<h3 id="-5">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR strIp</td>
<td>是</td>
<td>127.0.0.1:1089</td>
<td>连接服务器地址</td>
</tr>
</tbody>
</table>
<h2 id="setserverip0a3ca20id3dsetserverip52843e203ca3e">setServerIp
<a id=setServerIp5284> </a></h2>
<p></p>
<h3 id="-6">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置会议服务器地址
</code></pre>
<h3 id="-7">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR</td>
<td>是</td>
<td></td>
<td>服务器IP,e.g: 127.0.0.1:1089</td>
</tr>
</tbody>
</table>
<h3 id="-8">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setclientidinfo0a3ca20id3dsetclientidinfo52843e203ca3e">setClientIdInfo
<a id=setClientIdInfo5284> </a></h2>
<p></p>
<h3 id="-9">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置登录认证参数，strOauthKey和strOauthSecret由服务器创建分发，可以从服务提供商处获取
</code></pre>
<h3 id="-10">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>const LSdkTokenParam&amp;</td>
<td>是</td>
<td></td>
<td>struct LSdkTokenParam<br/>{<br/>	FString strOauthKey; <br/>	FString strOauthSecret;<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-11">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="getaudiomanager0a3ca20id3dgetaudiomanager52843e203ca3e">getAudioManager
<a id=getAudioManager5284> </a></h2>
<p></p>
<h3 id="-12">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取音频管理类AudioManager实例,管理类不需要用户自行创建，SDK初始化时会自动创建实例
</code></pre>
<h3 id="-13">参数</h3>
<h2 id="getchatmanager0a3ca20id3dgetchatmanager52843e203ca3e">getChatManager
<a id=getChatManager5284> </a></h2>
<p></p>
<h3 id="-14">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p><span class="colour" style="color:rgb(85, 85, 85)"></span></p>
<pre><code>获取聊天管理类ChatManager实例,管理类不需要用户自行创建，SDK初始化时会自动创建实例
</code></pre>
<h3 id="-15">参数</h3>
<h2 id="getloginmanager0a3ca20id3dgetloginmanager52843e203ca3e">getLoginManager
<a id=getLoginManager5284> </a></h2>
<p></p>
<h3 id="-16">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取登录管理类LoginManager实例,管理类不需要用户自行创建，SDK初始化时会自动创建实例
</code></pre>
<h3 id="-17">参数</h3>
<h2 id="getmeetingmanager0a3ca20id3dgetmeetingmanager52843e203ca3e">getMeetingManager
<a id=getMeetingManager5284> </a></h2>
<p></p>
<h3 id="-18">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取会议管理类MeetingManager实例,管理类不需要用户自行创建，SDK初始化时会自动创建实例
</code></pre>
<h3 id="-19">参数</h3>
<h2 id="getsdkmanager0a3ca20id3dgetsdkmanager52843e203ca3e">getSdkManager
<a id=getSdkManager5284> </a></h2>
<p></p>
<h3 id="-20">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取SdkManager，SdkManager 为单例
</code></pre>
<h3 id="-21">参数</h3>
<h2 id="getscreensharemanager0a3ca20id3dgetscreensharemanager52843e203ca3e">getScreenShareManager
<a id=getScreenShareManager5284> </a></h2>
<p></p>
<h3 id="-22">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取屏幕共享管理类ScreenShareManager实例,管理类不需要用户自行创建，SDK初始化时会自动创建实例
</code></pre>
<h3 id="-23">参数</h3>
<h2 id="getusermanager0a3ca20id3dgetusermanager52843e203ca3e">getUserManager
<a id=getUserManager5284> </a></h2>
<p></p>
<h3 id="-24">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取用户管理类UserManager实例,管理类不需要用户自行创建，SDK初始化时会自动创建实例
</code></pre>
<h3 id="-25">参数</h3>
<h2 id="getvideomanager0a3ca20id3dgetvideomanager52843e203ca3e">getVideoManager
<a id=getVideoManager5284> </a></h2>
<p></p>
<h3 id="-26">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p><span class="colour" style="color:rgb(85, 85, 85)"></span></p>
<pre><code>获取视频管理类VideoManager实例,管理类不需要用户自行创建，SDK初始化时会自动创建实例
</code></pre>
<h3 id="-27">参数</h3>
<h2 id="getsdkversion0a3ca20id3dgetsdkversion52843e203ca3e">getSdkVersion
<a id=getSdkVersion5284> </a></h2>
<p></p>
<h3 id="-28">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p>获取版本号，返回字符串</p>
<h3 id="-29">参数</h3>
<h3 id="-30">返回数据</h3>
<pre><code class="language-javascript">FString
</code></pre>
<h2 id="releasesdk0a3ca20id3dreleasesdk52843e203ca3e">releaseSdk
<a id=releaseSdk5284> </a></h2>
<p></p>
<h3 id="-31">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>程序退出，释放SDK资源，每次应用运行只能调用一次，不可多次加载释放。
改接口需要在EV_LOGIN_EXIT_ROOM事件之后调用
</code></pre>
<h3 id="-32">参数</h3>
<h3 id="-33">返回数据</h3>
<pre><code class="language-javascript">{&quot;type&quot;:&quot;object&quot;,&quot;title&quot;:&quot;title&quot;,&quot;properties&quot;:{}}
</code></pre>
<h1 id="loginmanager28u767bu5f55u7ba1u7406u7c7b29">LoginManager(登录管理类)</h1>
<p></p>
<h2 id="addeventlistener0a3ca20id3daddeventlistener52883e203ca3e">addEventListener
<a id=addEventListener5288> </a></h2>
<p></p>
<h3 id="-34">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_LOGIN_ENV_INIT
说明：会前初始化完成事件，可以开始登录

EV_LOGIN_RESULT
说明：登录事件结果

EV_LOGIN_ROOM_INIT
说明：会中组件初始化完成事件，可以绑定所有管理类回调事件

EV_LOGIN_EXIT_ROOM
自己退出会议室完成通知
</code></pre>
<h3 id="-35">参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/x-www-form-urlencoded</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数类型</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>SNOTIFY</td>
<td>text</td>
<td>是</td>
<td></td>
<td>监听回调函数</td>
</tr>
</tbody>
</table>
<h3 id="-36">返回数据</h3>
<pre><code class="language-javascript">{&quot;type&quot;:&quot;object&quot;,&quot;title&quot;:&quot;title&quot;,&quot;properties&quot;:{}}
</code></pre>
<h2 id="enterroom0a3ca20id3denterroom52883e203ca3e">enterRoom
<a id=enterRoom5288> </a></h2>
<p></p>
<h3 id="-37">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>入会
</code></pre>
<h3 id="-38">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL bIsMine</td>
<td>是</td>
<td></td>
<td>是否我的会议室（从列表入会）</td>
</tr>
<tr>
<td>S_INT32 dwRoomID</td>
<td>是</td>
<td></td>
<td>会议ID</td>
</tr>
<tr>
<td>S_PWCHAR pRoomPwd</td>
<td>是</td>
<td></td>
<td>会议密码</td>
</tr>
</tbody>
</table>
<h3 id="-39">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="loginaccount0a3ca20id3dloginaccount52883e203ca3e">loginAccount
<a id=loginAccount5288> </a></h2>
<p></p>
<h3 id="-40">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>用户名密码登录
</code></pre>
<h3 id="-41">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR pName</td>
<td>是</td>
<td></td>
<td>用户名</td>
</tr>
<tr>
<td>S_PWCHAR pPwd</td>
<td>是</td>
<td></td>
<td>用户密码</td>
</tr>
</tbody>
</table>
<h3 id="-42">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="loginroomid0a3ca20id3dloginroomid52883e203ca3e">loginRoomID
<a id=loginRoomID5288> </a></h2>
<p></p>
<h3 id="-43">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>会议号/邀请码加入会议
</code></pre>
<h3 id="-44">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR pNickname</td>
<td>是</td>
<td></td>
<td>昵称</td>
</tr>
<tr>
<td>S_INT32 dwRoomID</td>
<td>是</td>
<td></td>
<td>会议室号/邀请码</td>
</tr>
<tr>
<td>S_PWCHAR pRoomPwd</td>
<td>是</td>
<td></td>
<td>会议室密码</td>
</tr>
</tbody>
</table>
<h3 id="-45">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="logout0a3ca20id3dlogout52883e203ca3e">logout
<a id=logout5288> </a></h2>
<p></p>
<h3 id="-46">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>退出登录
</code></pre>
<h3 id="-47">参数</h3>
<h3 id="-48">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="cancelenterroom0a3ca20id3dcancelenterroom52883e203ca3e">cancelEnterRoom
<a id=cancelEnterRoom5288> </a></h2>
<p></p>
<h3 id="-49">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>取消入会
</code></pre>
<h3 id="-50">参数</h3>
<h3 id="-51">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h1 id="meetingmanager28u4f1au63a7u7ba1u7406u7c7b29">MeetingManager(会控管理类)</h1>
<p></p>
<h2 id="addeventlistener0a3ca20id3daddeventlistener52923e203ca3e">addEventListener
<a id=addEventListener5292> </a></h2>
<p></p>
<h3 id="-52">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_MEETING_ENTER
说明：自己入会成功事件

EV_MEETING_CLOSE
说明：会议室关闭通知

EV_MEETING_KICK
说明：被踢出会议室通知

EV_MEETING_LOCK
说明：房间锁定状态通知

EV_MEETING_ENTER_LOCK
说明：用户进入被锁房间通知

EV_MEETING_LAYOUT
说明：会议布局消息通知
</code></pre>
<h3 id="-53">参数</h3>
<h2 id="broadcastlayout0a3ca20id3dbroadcastlayout52923e203ca3e">broadcastLayout
<a id=broadcastLayout5292> </a></h2>
<p></p>
<h3 id="-54">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>广播布局，需要根据当前本地的布局自行构建布局结构体，调用此接口后会广播布局给其他参会人，其他参会人收到布局结构后调整布局即可
</code></pre>
<h3 id="-55">参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>const LMeetingLayoutInfo&amp;</td>
<td></td>
<td>是</td>
<td></td>
<td>//会议室窗口布局类<br/>struct RoomWndState<br/>{<br/>	//区域布局风格<br/>	enum AreaLayoutStyle<br/>	{<br/>		AREA_LAYOUT_STYLE_TILE = 0,   //平铺风格类型<br/>		AREA_LAYOUT_STYLE_TABLE = 1,//tab切换风格类型<br/>		AREA_LAYOUT_STYLE_SPLIT = 2, //分屏风格类型<br/>		AREA_LAYOUT_STYLE_POP = 3   //弹出风格类型<br/>	};<br/><br/>	//会议室窗口布局模式<br/>	enum LayoutMode<br/>	{<br/>		LAYOUT_MODE_NORMAL = 1,//默认模式<br/>		LAYOUT_MODE_DATA,		//数据模式<br/>		LAYOUT_MODE_VIDEO,		//视频固定模式（1~64分屏）<br/>		LAYOUT_MODE_DATAFULL,	//视频模式全屏<br/>	};<br/><br/>	//分屏风格<br/>	enum SplitStyle<br/>	{<br/>		SPLIT_STYLE_AUTO = 0,	//默认自动<br/>		SPLIT_STYLE_1 = 1,		//一分屏<br/>		SPLIT_STYLE_2 = 2,<br/>		SPLIT_STYLE_P_IN_P = 3,	//画中画<br/>		SPLIT_STYLE_4 = 4,<br/>		SPLIT_STYLE_6 = 6,<br/>		SPLIT_STYLE_9 = 9,<br/>		SPLIT_STYLE_12 = 12,<br/>		SPLIT_STYLE_16 = 16,<br/>		SPLIT_STYLE_25 = 25,<br/>		SPLIT_STYLE_36 = 36,<br/>		SPLIT_STYLE_49 = 49,<br/>		SPLIT_STYLE_64 = 64,<br/>		SPLIT_STYLE_NO = 50,       //无分屏（如无视频/纯语音，兼容某个版本应用）<br/>		SPLIT_STYLE_1_FOCUS = 1001, //一焦点<br/>		SPLIT_STYLE_2_FOCUS = 1002, //2焦点<br/>	};<br/><br/>	//数据类型<br/>	enum DataType<br/>	{<br/>		DATA_TYPE_CONTAINER = 0,    //默认,容器类型，（如视频区域，可以显示数据，则用容器类型<br/>		DATA_TYPE_WB = 1,                  //白板<br/>		DATA_TYPE_APPSHARE = 2,      //屏幕共享<br/>		DATA_TYPE_WEB = 3,                //Web协同浏览<br/>		DATA_TYPE_MEDIASHARE = 4, //媒体共享<br/>		DATA_TYPE_VOTE = 5,              //电子投票<br/>		DATA_TYPE_VIDEO = 6,            //视频<br/>		DATA_TYPE_VIDEOPOLLING = 7//视频轮巡<br/>	};<br/><br/>	//数据块信息<br/>	struct DataBlock<br/>	{<br/>		S_BYTE		pos = 0;		//索引顺序<br/>		DataType	data_type = DATA_TYPE_CONTAINER;	//类型<br/>		S_UINT32	data_id = 0;	        //业务数据ID <br/>									//白板和电子投票有id<br/>									//视频,屏幕共享，媒体共享 为用户ID //，其他的需要在创建的时候手动生成<br/>									//视频轮询id<br/>		S_UINT32	user_data = 0;	        //用户自定义类型<br/>									//白板和电子投票有 空<br/>									//视频 通道ID<br/>									//屏幕共享，媒体共享 为空 //，其他的需要在创建的时候手动生成<br/>									//视频轮巡类型（0本地轮巡，1广播轮询<br/>	};<br/><br/>	typedef LVector&lt;DataBlock&gt; DataBlockVector;<br/><br/>	//数据区域信息<br/>	struct AreaData<br/>	{<br/>		S_BYTE				id = 0;<br/>		S_BYTE				screen_id = 0;					//所属屏ID<br/>		AreaLayoutStyle		style = AREA_LAYOUT_STYLE_TILE;	//区域布局样式<br/>		S_UINT32			user_data = 0;					//自定义字段<br/>														//新版本（tab风格中为当前选中的数据块pos；split分屏风格中为：SplitStyle，多少分屏）<br/>														//所以需要应用层自己查找到对应pos,白板则需要继续以白板的active回调设置的当前激活白板<br/>														//如果主讲是老版本，未使用新协议进行交互，splite 一样，tab风格中则userData字段值为：当前选中的数据类型			<br/>		DataBlockVector		data_block_vector;				//数据块列表<br/>	};<br/><br/>	struct FullArea<br/>	{<br/>		AreaLayoutStyle		style = AREA_LAYOUT_STYLE_TILE;	//全屏区域风格<br/>		S_UINT32			user_data = 0;//自定义字段，暂时无用<br/>		typedef LVector&lt;S_BYTE&gt;	IDVector;<br/>		IDVector			id_set;	              //全屏区域显示的区域ID集合<br/>									      //包含全屏下需要显示的区域ID<br/>									      //根据idSet是否为空判断，当前是否存在区域处于全屏状态<br/>	};<br/><br/>	S_BYTE		screen_id = 0;	                     //屏幕ID<br/>								             //用以区分主屏/分屏，从0递增<br/>								             //可扩展用于同步分屏上的布局	<br/><br/>	LayoutMode	layout_mode = LAYOUT_MODE_NORMAL;	//原 bMode 客户端的当前屏的布局模式<br/>													//（标准布局/数据布局/视频布局）<br/>													//可扩展用于新的布局模式<br/><br/>	FullArea	full_area;	//全屏区域<br/>							//FullType	fullType;	//原 bFull 客户端全屏风格<br/>							//（自动/数据全屏/视频全屏/数据+主讲视频全屏/数据+视频全屏）<br/>							//可扩展用户全屏模式下的风格<br/><br/>	AreaData	tab_area;	//tab风格区域<br/>							//（windows客户端数据区域）<br/>							//可扩展，一个屏可以有多个tab风格区域<br/><br/>	AreaData	split_area;	//split风格区域<br/>							//（视频区域）<br/>							//可扩展，一个屏可以有多个split风格区域<br/><br/>	DataBlock	full_data_block;//原FullVideoMedia<br/>							//单个全屏的数据款（单个视频选择全屏）<br/>							//可扩展，用于单独全屏任何数据模块<br/>};<br/><br/>typedef LVector&lt;RoomWndState&gt;	RoomWndStateVector;<br/><br/>struct LMeetingLayoutInfo<br/>{<br/>	S_BOOL				valid_full_mode;//保持全屏模式（即使同步信息中为非全屏，也不退出全屏）<br/>	S_UINT32			user;		//同步者<br/>	RoomWndStateVector	wnd_state;	//窗口布局<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-56">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="closemeeting0a3ca20id3dclosemeeting52923e203ca3e">closeMeeting
<a id=closeMeeting5292> </a></h2>
<p></p>
<h3 id="-57">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>关闭会议室，调用此接口后会议室中参会人员都会被请出会议室，需要权限支持
</code></pre>
<h3 id="-58">参数</h3>
<h2 id="exitmeeting0a3ca20id3dexitmeeting52923e203ca3e">exitMeeting
<a id=exitMeeting5292> </a></h2>
<p></p>
<h3 id="-59">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>参会人员主动退出会议室
</code></pre>
<h3 id="-60">参数</h3>
<h2 id="getalloperateaudio0a3ca20id3dgetalloperateaudio52923e203ca3e">getAllOperateAudio
<a id=getAllOperateAudio5292> </a></h2>
<p></p>
<h3 id="-61">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p><span class="colour" style="color:rgb(85, 85, 85)"></span></p>
<pre><code>获取是否允许参会人自我解除静音
</code></pre>
<h3 id="-62">参数</h3>
<h3 id="-63">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="getlocalrecordparam0a3ca20id3dgetlocalrecordparam52923e203ca3e">getLocalRecordParam
<a id=getLocalRecordParam5292> </a></h2>
<p></p>
<h3 id="-64">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取录制参数
</code></pre>
<h3 id="-65">参数</h3>
<h3 id="-66">返回数据</h3>
<pre><code class="language-javascript">const LRecordParam&amp;
struct LRecordParam
{
	enum class RecordType : BYTE
	{
		RECORDTYPE_MP4 = 2,				//mp4
		RECORDTYPE_WMV = 3,				//wmv
		RECORDTYPE_WMA = 4				//wma
	};
	enum class RecordQuality : BYTE
	{
		RECORDQUALITY_LOW = 1,			//录制质量低
		RECORDQUALITY_MEDIUM = 2,		//录制质量中
		RECORDQUALITY_HIGH = 3			//录制质量高
	};
	enum class RecordRect : BYTE
	{
		RECORDRECT_FULL = 1,			//录制当前桌面窗口
		RECORDRECT_SELF = 2,			//录制程序窗口
		RECORDRECT_SPECIAL = 3			//录制指定区域
	};

	RecordType		record_type;		//保存录制文件格式类型
	RecordQuality	record_quality;		//质量
	RecordRect		record_rect;		//需要录制的方式
	HWND			capture_hwnd;		//录制的窗口句柄
	RECT			record_area;		//录制区域
};
</code></pre>
<h2 id="getmeetinginfo0a3ca20id3dgetmeetinginfo52923e203ca3e">getMeetingInfo
<a id=getMeetingInfo5292> </a></h2>
<p></p>
<h3 id="-67">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取会议室信息
会议室类型不同获取的数据也不相同
</code></pre>
<h3 id="-68">参数</h3>
<h3 id="-69">返回数据</h3>
<pre><code class="language-javascript">const LMeetingInfo&amp;
struct LMeetingInfo
{
	S_UINT32 roomID = 0;      //会议室ID
	S_UINT32 curCount = 0;	  //会议当前在线人数
	S_UINT32 maxCount = 0; //最大在线人数
	S_UINT32 userID = 0;      //会议室创建者ID
	FString roomName;		//会议室名称
	FString inviteCode;		//邀请码
};
</code></pre>
<h2 id="isvoiceincentiveenable0a3ca20id3disvoiceincentiveenable52923e203ca3e">isVoiceIncentiveEnable
<a id=isVoiceIncentiveEnable5292> </a></h2>
<p></p>
<h3 id="-70">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>查询当前会议室是否启用语音激励，开启语音激励后，代表需要按音量大小进行排序
</code></pre>
<h3 id="-71">参数</h3>
<h3 id="-72">返回数据</h3>
<pre><code class="language-javascript">S_BOOL  TRUE：已经开启  FALSE：未开启

</code></pre>
<h2 id="pauselocalrecord0a3ca20id3dpauselocalrecord52923e203ca3e">pauseLocalRecord
<a id=pauseLocalRecord5292> </a></h2>
<p></p>
<h3 id="-73">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>调用改接口之前请先开始录制
</code></pre>
<h3 id="-74">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE ：暂停录制<br/>FALSE：继续录制</td>
</tr>
</tbody>
</table>
<h3 id="-75">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setlocalrecordparam0a3ca20id3dsetlocalrecordparam52923e203ca3e">setLocalRecordParam
<a id=setLocalRecordParam5292> </a></h2>
<p></p>
<h3 id="-76">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置参数前，需要先获取参数，再修改需要变更的参数。
</code></pre>
<h3 id="-77">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>LRecordParam&amp;</td>
<td>是</td>
<td></td>
<td>录制参数<br/>struct LRecordParam<br/>{<br/>	enum class RecordType : BYTE<br/>	{<br/>		RECORDTYPE_MP4 = 2,				//mp4<br/>		RECORDTYPE_WMV = 3,				//wmv<br/>		RECORDTYPE_WMA = 4				//wma<br/>	};<br/>	enum class RecordQuality : BYTE<br/>	{<br/>		RECORDQUALITY_LOW = 1,			//录制质量低<br/>		RECORDQUALITY_MEDIUM = 2,		//录制质量中<br/>		RECORDQUALITY_HIGH = 3			//录制质量高<br/>	};<br/>	enum class RecordRect : BYTE<br/>	{<br/>		RECORDRECT_FULL = 1,			//录制当前桌面窗口<br/>		RECORDRECT_SELF = 2,			//录制程序窗口<br/>		RECORDRECT_SPECIAL = 3			//录制指定区域<br/>	};<br/><br/>	RecordType		record_type;		//保存录制文件格式类型<br/>	RecordQuality	record_quality;		//质量<br/>	RecordRect		record_rect;		//需要录制的方式<br/>	HWND			capture_hwnd;		//录制的窗口句柄<br/>	RECT			record_area;		//录制区域<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-78">返回数据</h3>
<pre><code class="language-javascript">设置录制
</code></pre>
<h2 id="startlocalrecord0a3ca20id3dstartlocalrecord52923e203ca3e">startLocalRecord
<a id=startLocalRecord5292> </a></h2>
<p></p>
<h3 id="-79">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>路径需要完整路径，Debug不能录制MP4。
开始、停止录制，是需要时间，请不要无间隔的一直调用接口，建议调用接口有少许时间间隔。
</code></pre>
<h3 id="-80">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR</td>
<td>是</td>
<td></td>
<td>录制保存文件名</td>
</tr>
</tbody>
</table>
<h3 id="-81">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="stoplocalrecord0a3ca20id3dstoplocalrecord52923e203ca3e">stopLocalRecord
<a id=stopLocalRecord5292> </a></h2>
<p></p>
<h3 id="-82">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>停止录制，录制操作是需要时间，请不要无间隔的一直调用接口，建议调用接口有少许时间间隔
</code></pre>
<h3 id="-83">参数</h3>
<h3 id="-84">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setalloperateaudio0a3ca20id3dsetalloperateaudio52923e203ca3e">setAllOperateAudio
<a id=setAllOperateAudio5292> </a></h2>
<p></p>
<h3 id="-85">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置允许参会人自我解除静音
</code></pre>
<h3 id="-86">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE： 允许<br/>FALSE：不允许</td>
</tr>
</tbody>
</table>
<h3 id="-87">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h1 id="usermanager28u7528u6237u7ba1u7406u7c7b29">UserManager(用户管理类)</h1>
<p></p>
<h2 id="abandonthemanager0a3ca20id3dabandonthemanager52963e203ca3e">abandonTheManager
<a id=abandonTheManager5296> </a></h2>
<p></p>
<h3 id="-88">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地用户放弃管理员身份
</code></pre>
<h3 id="-89">参数</h3>
<h3 id="-90">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="addeventlistener0a3ca20id3daddeventlistener52963e203ca3e">addEventListener
<a id=addEventListener5296> </a></h2>
<p></p>
<h3 id="-91">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_USER_ENTER
说明：用户进入房间通知

EV_USER_LEAVE
说明：用户退出房间通知

EV_USER_ADMIN
说明：管理员身份状态通知

EV_USER_INFO_CHANGE
说明：用户身份信息变更通知

EV_USER_ADMIN_APPLY
说明：管理员身份申请通知

EV_USER_PRESENTER
说明：主持人身份状态通知
</code></pre>
<h3 id="-92">参数</h3>
<h2 id="agreeknockuser0a3ca20id3dagreeknockuser52963e203ca3e">agreeKnockUser
<a id=agreeKnockUser5296> </a></h2>
<p></p>
<h3 id="-93">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>同意或者拒绝敲门用户进入锁定的房间。当会议室锁定之后场景使用
</code></pre>
<h3 id="-94">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>敲门用户ID</td>
</tr>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE：同意<br/>FALSE：拒绝</td>
</tr>
</tbody>
</table>
<h3 id="-95">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="abandonthehost0a3ca20id3dabandonthehost52963e203ca3e">abandonTheHost
<a id=abandonTheHost5296> </a></h2>
<p></p>
<h3 id="-96">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地用户放弃主持人身份
</code></pre>
<h3 id="-97">参数</h3>
<h3 id="-98">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="agreetobehost0a3ca20id3dagreetobehost52963e203ca3e">agreeToBeHost
<a id=agreeToBeHost5296> </a></h2>
<p></p>
<h3 id="-99">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>同意\不同意远端用户成为主持人的申请,需要权限
</code></pre>
<h3 id="-100">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被操作用户Id</td>
</tr>
<tr>
<td>S_BOOL bAgree</td>
<td>是</td>
<td></td>
<td>TRUE： 同意<br/>FALSE：拒绝</td>
</tr>
</tbody>
</table>
<h3 id="-101">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="applytobehost0a3ca20id3dapplytobehost52963e203ca3e">applyToBeHost
<a id=applyToBeHost5296> </a></h2>
<p></p>
<h3 id="-102">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地用户申请成为主持人,需要权限
</code></pre>
<h3 id="-103">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE： 申请主持人<br/>FALSE：放弃申请主持人</td>
</tr>
</tbody>
</table>
<h3 id="-104">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="applytobemanager0a3ca20id3dapplytobemanager52963e203ca3e">applyToBeManager
<a id=applyToBeManager5296> </a></h2>
<p></p>
<h3 id="-105">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地用户申请成为管理员
</code></pre>
<h3 id="-106">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR pPwd</td>
<td>是</td>
<td></td>
<td>会议室密码，没有为空</td>
</tr>
</tbody>
</table>
<h3 id="-107">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="getallusers0a3ca20id3dgetallusers52963e203ca3e">getAllUsers
<a id=getAllUsers5296> </a></h2>
<p></p>
<h3 id="-108">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>返回当前会议室所有的用户
</code></pre>
<h3 id="-109">参数</h3>
<h3 id="-110">返回数据</h3>
<pre><code class="language-javascript">const LVector&lt;RoomUserInfo&gt;&amp;
struct RoomUserInfo
{
	S_BYTE			type = 0;					//用户类型,注册或非注册0 非注册， 1 注册
	S_BYTE			level = 0;					//用户级别
	S_BYTE			is_offline = 0;  			//是否离线
	S_UINT32		id = 0;						//ID

	int				terminal = 0;				//终端类型
	FString			username;					//username
	FString			role;						//角色信息

	FString			ip_address;					//ip
	FString			dept_id;					//部门id
	FString			node_id;					//登陆节点

	struct State
	{
		S_BYTE			presenter;			    //主讲状态presenter
		S_BYTE			data_sharer;			//共享人状态
		S_BYTE			phone_invite;			//电话邀请权限 0，无权限，1，已授权。
		S_BYTE			out_mute;				//静音状态
		S_BYTE			group_meeting;			//分组会议状态
		S_BYTE			super_manager;			//初始管理员
		S_BYTE			manager = 0;			//管理员状态
		S_BYTE			speaker_state;			//扬声器状态
		S_BYTE			local_record;			//本地录制状态
	};
	State			state;						//状态信息


	struct MediaShare							//媒体共享信息
	{
		S_BYTE			state;					//状态
		S_BYTE			is_restore;				//恢复状态（因为state==DONE 的时候可能是开始，和恢复）
		S_BYTE			audio_channel;			//音频通道
		S_BYTE			video_channel;			//视频通道
	};
	MediaShare		media_share;			//媒体共享信息

	struct AppShare								//屏幕共享信息
	{
		S_BYTE			state;					//状态
		S_BYTE			audio_channel;			//共享音频
	};
	AppShare		app_share;

	struct Contact								//联系信息
	{
		S_BYTE			sex;					//性别
		FString			nickname;				//昵称
		FString			telphone;				//电话
	};

	Contact			contact;				//联系信息
	AudioChannel	audio_channel;			//音频数据
	VideoChannel	video_channels[6];		//视频数据
	S_INT32			cur_virtual_dev;		//当前虚拟视频设备
	S_INT32			default_video_dev;		//默认的摄像头设备ID
};
</code></pre>
<h2 id="getcurrenthost0a3ca20id3dgetcurrenthost52963e203ca3e">getCurrentHost
<a id=getCurrentHost5296> </a></h2>
<p></p>
<h3 id="-111">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取当前会议室中主持人用户id
</code></pre>
<h3 id="-112">参数</h3>
<h3 id="-113">返回数据</h3>
<pre><code class="language-javascript">S_UINT32
</code></pre>
<h2 id="getlocaluser0a3ca20id3dgetlocaluser52963e203ca3e">getLocalUser
<a id=getLocalUser5296> </a></h2>
<p></p>
<h3 id="-114">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取当前本地用户信息
</code></pre>
<h3 id="-115">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>RoomUserInfo&amp;</td>
<td>是</td>
<td></td>
<td>struct RoomUserInfo<br/>{<br/>	byte			type;				//用户类型,注册或非注册0 非注册， 1 注册										<br/>	byte			level;				//用户级别<br/>	byte			is_offline;  			//是否离线<br/>	unsigned int	id;					//ID<br/>	unsigned int    src_user_id;                      //消息来源用户id, 为0表示由服务器自己触发发送，而非客户端<br/>	unsigned int	buy_server_flag;		//购买的服务 0 无任何服务 loki 2014-12-12  0x000000000000000<br/>	unsigned int	terminal;				//终端类型<br/>	unsigned int	language;			//语言code<br/>	const char*	receive_language;           //同声传译，用户指定的交互语言<br/>	const char*	username;		        //username<br/>	const char*	role;			                //角色信息<br/>	const char*	ip_address;		         //ip<br/>	const char*	dept_id;			         //部门id<br/>	const char*	node_id;			         //登陆节点<br/>}</td>
</tr>
</tbody>
</table>
<h3 id="-116">返回数据</h3>
<pre><code class="language-javascript">S_UINT32
</code></pre>
<h2 id="getuserinfo0a3ca20id3dgetuserinfo52963e203ca3e">getUserInfo
<a id=getUserInfo5296> </a></h2>
<p></p>
<h3 id="-117">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>通过用户ID获取用户信息
</code></pre>
<h3 id="-118">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>查询用户Id</td>
</tr>
</tbody>
</table>
<h3 id="-119">返回数据</h3>
<pre><code class="language-javascript">const RoomUserInfo*
</code></pre>
<h2 id="getonlineusercount0a3ca20id3dgetonlineusercount52963e203ca3e">getOnlineUserCount
<a id=getOnlineUserCount5296> </a></h2>
<p></p>
<h3 id="-120">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code> 获取当前参会人数，在线人数
</code></pre>
<h3 id="-121">参数</h3>
<h3 id="-122">返回数据</h3>
<pre><code class="language-javascript">S_UINT32
</code></pre>
<h2 id="grantthehostforremoteuser0a3ca20id3dgrantthehostforremoteuser52963e203ca3e">grantTheHostForRemoteUser
<a id=grantTheHostForRemoteUser5296> </a></h2>
<p></p>
<h3 id="-123">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>授予或者取消指定参会人主持人身份,需要权限
</code></pre>
<h3 id="-124">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被操作者ID</td>
</tr>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE 设置主持人<br/>FALSE 取消主持人</td>
</tr>
</tbody>
</table>
<h3 id="-125">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="grantthemanagerforremoteuser0a3ca20id3dgrantthemanagerforremoteuser52963e203ca3e">grantTheManagerForRemoteUser
<a id=grantTheManagerForRemoteUser5296> </a></h2>
<p></p>
<h3 id="-126">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>授予/取消 指定参会人管理员身份,需要权限
</code></pre>
<h3 id="-127">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被操作者ID</td>
</tr>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE 设置管理员<br/>FALSE 取消管理员</td>
</tr>
</tbody>
</table>
<h3 id="-128">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="hashost0a3ca20id3dhashost52963e203ca3e">hasHost
<a id=hasHost5296> </a></h2>
<p></p>
<h3 id="-129">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>当前会议室是否存在主持人
</code></pre>
<h3 id="-130">参数</h3>
<h3 id="-131">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="kickuser0a3ca20id3dkickuser52963e203ca3e">kickUser
<a id=kickUser5296> </a></h2>
<p></p>
<h3 id="-132">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>将当前参会的某个用户请出会议室，需要权限支持
</code></pre>
<h3 id="-133">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被请出会议用户的ID</td>
</tr>
</tbody>
</table>
<h3 id="-134">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="modifyusernickname0a3ca20id3dmodifyusernickname52963e203ca3e">modifyUserNickname
<a id=modifyUserNickname5296> </a></h2>
<p></p>
<h3 id="-135">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>修改参会人昵称
</code></pre>
<h3 id="-136">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被修改的用户id</td>
</tr>
<tr>
<td>S_PWCHAR pNickName</td>
<td>是</td>
<td></td>
<td>修改后的昵称</td>
</tr>
</tbody>
</table>
<h3 id="-137">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h1 id="videomanager28u89c6u9891u7ba1u7406u7c7b29">VideoManager(视频管理类)</h1>
<p></p>
<h2 id="pausevideo0a3ca20id3dpausevideo53003e203ca3e">pauseVideo
<a id=pauseVideo5300> </a></h2>
<p></p>
<h3 id="-138">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>暂停用户视频
</code></pre>
<h3 id="-139">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>用户ID</td>
</tr>
<tr>
<td>S_BYTE channel</td>
<td>是</td>
<td></td>
<td>用户视频通道</td>
</tr>
<tr>
<td>S_BOOL pause</td>
<td>是</td>
<td></td>
<td>是否暂停</td>
</tr>
</tbody>
</table>
<h3 id="-140">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="startcheckvideoview0a3ca20id3dstartcheckvideoview53003e203ca3e">startCheckVideoView
<a id=startCheckVideoView5300> </a></h2>
<p></p>
<h3 id="-141">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>开始接收渲染或者查看他人视频，查看他人视频需要权限。当收到远端用户成功广播视频的消息之后，需要调用本方法进行远端视频的渲染展示。查看远端视频也是此接口
</code></pre>
<h3 id="-142">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被查看者用户ID</td>
</tr>
<tr>
<td>S_BYTE channel</td>
<td>是</td>
<td></td>
<td>查看摄像头ID</td>
</tr>
<tr>
<td>HWND hWnd</td>
<td>是</td>
<td></td>
<td>显示视频的窗口句柄</td>
</tr>
</tbody>
</table>
<h3 id="-143">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="stopcheckvideoview0a3ca20id3dstopcheckvideoview53003e203ca3e">stopCheckVideoView
<a id=stopCheckVideoView5300> </a></h2>
<p></p>
<h3 id="-144">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地停止接收渲染他人广播的视频或者停止查看他人视频。channel 为用户视通道信息，从RoomUserInfo中 VideoChannel获取通道id信息
</code></pre>
<h3 id="-145">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被查看者用户ID</td>
</tr>
<tr>
<td>S_BYTE channel</td>
<td>是</td>
<td></td>
<td>查看摄像头ID</td>
</tr>
</tbody>
</table>
<h3 id="-146">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="startlocalvideopreview0a3ca20id3dstartlocalvideopreview53003e203ca3e">startLocalVideoPreview
<a id=startLocalVideoPreview5300> </a></h2>
<p></p>
<h3 id="-147">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>开启本地视频预览，传入HWND窗口句柄，视频将会在该HWND上渲染出来。窗口需要为可见窗口
</code></pre>
<h3 id="-148">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BYTE device_id</td>
<td>是</td>
<td></td>
<td>设备ID</td>
</tr>
<tr>
<td>HWND render_wnd</td>
<td>是</td>
<td></td>
<td>显示窗口句柄</td>
</tr>
</tbody>
</table>
<h3 id="-149">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="stoplocalvideopreview0a3ca20id3dstoplocalvideopreview53003e203ca3e">stopLocalVideoPreview
<a id=stopLocalVideoPreview5300> </a></h2>
<p></p>
<h3 id="-150">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>停止本地视频的预览
</code></pre>
<h3 id="-151">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BYTE device_id</td>
<td>是</td>
<td></td>
<td>设备ID</td>
</tr>
</tbody>
</table>
<h3 id="-152">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="agreeapplyvideo0a3ca20id3dagreeapplyvideo53003e203ca3e">agreeApplyVideo
<a id=agreeApplyVideo5300> </a></h2>
<p></p>
<h3 id="-153">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>同意/不同意远端用户广播视频的请求，需要拥有设置权限。同意之后，所有的参会人员会收到用户视频广播的消息，收到这个消息后各参会人需要调用startCheckVideoView来进行该用户视频的渲染展示
</code></pre>
<h3 id="-154">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被操作用户ID</td>
</tr>
<tr>
<td>S_BYTE channel</td>
<td>是</td>
<td></td>
<td>设置ID</td>
</tr>
<tr>
<td>S_BOOL bAgree</td>
<td>是</td>
<td></td>
<td>TRUE ：同意关播视频<br/>FALSE：拒绝广播视频</td>
</tr>
</tbody>
</table>
<h3 id="-155">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="addeventlistener0a3ca20id3daddeventlistener53003e203ca3e">addEventListener
<a id=addEventListener5300> </a></h2>
<p></p>
<h3 id="-156">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_VIDEO_MEDIA_MSG
说明：用户视频状态改变消息

EV_VIDEO_DEVICE_STATE
说明：用户视频设备改变消息
</code></pre>
<h3 id="-157">参数</h3>
<h2 id="broadcastvideo0a3ca20id3dbroadcastvideo53003e203ca3e">broadcastVideo
<a id=broadcastVideo5300> </a></h2>
<p></p>
<h3 id="-158">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地用户广播视频，需要权限 广播用户视频,可以是本地用户也可以是远端用户。channel 为用户视通道信息，从RoomUserInfo中 VideoChannel获取通道信息。VideoChannel与摄像头一一对应。当其他参会用户收到本用户的广播消息之后，便可调用startCheckVideoView进行视频的渲染。
</code></pre>
<h3 id="-159">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被操作者用户ID</td>
</tr>
<tr>
<td>S_BYTE channel</td>
<td>是</td>
<td></td>
<td>广播的设备Id</td>
</tr>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE： 广播视频<br/>FALSE：停止广播视频</td>
</tr>
</tbody>
</table>
<h3 id="-160">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="applybroadcastvideo0a3ca20id3dapplybroadcastvideo53003e203ca3e">applyBroadcastVideo
<a id=applyBroadcastVideo5300> </a></h2>
<p></p>
<h3 id="-161">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地用户申请广播自己的视频或者关闭申请。调用此方法后所有参会用户会收到本用户的广播的申请，有权限同意的用户可以调用agreeApplyVideo接口进行同意/不同意用户申请。
</code></pre>
<h3 id="-162">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BYTE channel</td>
<td>是</td>
<td></td>
<td>设备ID</td>
</tr>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE ：申请广播<br/>FALSE：取消申请广播</td>
</tr>
</tbody>
</table>
<h3 id="-163">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setcameraenable0a3ca20id3dsetcameraenable53003e203ca3e">setCameraEnable
<a id=setCameraEnable5300> </a></h2>
<p></p>
<h3 id="-164">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置本地摄像头状态，本地视频广播状态下，禁用摄像头后远端则收不到本地视频流
</code></pre>
<h3 id="-165">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL bEnable</td>
<td>是</td>
<td></td>
<td>TRUE ：可用<br/>FALSE：不可用</td>
</tr>
</tbody>
</table>
<h3 id="-166">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="getvideoparam0a3ca20id3dgetvideoparam53003e203ca3e">getVideoParam
<a id=getVideoParam5300> </a></h2>
<p></p>
<h3 id="-167">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取视频设备属性，deviceId 为RoomUserInfo 中 VideoChannel 中数据的id值。VideoChannel与摄像头设备一一对相应
</code></pre>
<h3 id="-168">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BYTE deviceId</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>VideoParamKey</td>
<td>是</td>
<td></td>
<td>enum VideoParamKey <br/>{<br/>	VIDOE_VALUE_RATE,				//帧率<br/>	VIDOE_VALUE_BITRATE,			        //码流<br/>	VIDOE_VALUE_ENCODMODE,			//锁定码流，0=恒定的质量目标来编码，1=恒定码率，2=平均码率<br/>	VIDOE_VALUE_ENCODERID,			//ENCODER_MPEG4=2，ENCODER_H264=3，ENCODER_H265=9<br/>	VIDOE_VALUE_MODAL,				//视频模式，0=平衡，1=流畅，2=清晰，3=自定义<br/>	VIDOE_VALUE_RESOLUTION,			//视频分辨率<br/>};</td>
</tr>
<tr>
<td>S_INT32&amp;</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-169">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setvideoparam0a3ca20id3dsetvideoparam53003e203ca3e">setVideoParam
<a id=setVideoParam5300> </a></h2>
<p></p>
<h3 id="-170">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置设备视频参数，deviceId 为RoomUserInfo 中 VideoChannel 中数据的id值。VideoChannel与摄像头设备一一对相应
</code></pre>
<h3 id="-171">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BYTE deviceId</td>
<td>是</td>
<td></td>
<td>查询设备ID</td>
</tr>
<tr>
<td>VideoParamKey</td>
<td>是</td>
<td></td>
<td>enum VideoParamKey<br/> {<br/>	VIDOE_VALUE_RATE,				//帧率<br/>	VIDOE_VALUE_BITRATE,			        //码流<br/>	VIDOE_VALUE_ENCODMODE,			//锁定码流，0=恒定的质量目标来编码，1=恒定码率，2=平均码率<br/>	VIDOE_VALUE_ENCODERID,			//ENCODER_MPEG4=2，ENCODER_H264=3，ENCODER_H265=9<br/>	VIDOE_VALUE_MODAL,				//视频模式，0=平衡，1=流畅，2=清晰，3=自定义<br/>	VIDOE_VALUE_RESOLUTION,			//视频分辨率<br/>};</td>
</tr>
<tr>
<td>S_INT32 value</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-172">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="getvideodevicelist0a3ca20id3dgetvideodevicelist53003e203ca3e">getVideoDeviceList
<a id=getVideoDeviceList5300> </a></h2>
<p></p>
<h3 id="-173">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取本地视频设备，摄像头数据列表，PC端支持多摄像头
</code></pre>
<h3 id="-174">参数</h3>
<h3 id="-175">返回数据</h3>
<pre><code class="language-javascript">const VideoDeviceList&amp;
struct VideoChannel
{
	S_BOOL			used = false;   //是否有效
	S_BYTE			id;				//媒体ID
	S_UINT32        render_id;      //渲染ID
	S_BYTE			state;			//视频广播状态 
	S_BYTE			is_have_video;	//设备是否有效
	S_BYTE			is_recv_video;	//是否接收该路视频
	LDeviceOperate	operation;		//操作
	FString			name;			//设备名称
	FString			alias;			//别名，应用层修改
	FString			identifier;		//设备唯一标识符
};
typedef LVector&lt;VideoChannel&gt;	VideoDeviceList;
</code></pre>
<h2 id="iscameraenable0a3ca20id3discameraenable53003e203ca3e">isCameraEnable
<a id=isCameraEnable5300> </a></h2>
<p></p>
<h3 id="-176">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p><br data-tomark-pass=""><br>
<br data-tomark-pass=""></p>
<pre><code>获取摄像头状态
</code></pre>
<h3 id="-177">参数</h3>
<h3 id="-178">返回数据</h3>
<pre><code class="language-javascript">S_BOOL  TRUE：已启用； FALSE：未启用
</code></pre>
<h2 id="setdefaultvideodevice0a3ca20id3dsetdefaultvideodevice53003e203ca3e">setDefaultVideoDevice
<a id=setDefaultVideoDevice5300> </a></h2>
<p></p>
<h3 id="-179">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p><br data-tomark-pass=""><br>
<br data-tomark-pass=""></p>
<pre><code>设置默认摄像头。deviceId 为RoomUserInfo 中 VideoChannel 中数据的id值。VideoChannel与摄像头设备一一对相应
</code></pre>
<h3 id="-180">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BYTE device_id</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-181">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setdisplaymode0a3ca20id3dsetdisplaymode53003e203ca3e">setDisplayMode
<a id=setDisplayMode5300> </a></h2>
<p></p>
<h3 id="-182">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置视频显示模式，deviceId 为RoomUserInfo 中 VideoChannel 中数据的id值。VideoChannel与摄像头设备一一对相应
</code></pre>
<h3 id="-183">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>S_BYTE deviceId</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>LDisPlayMode option</td>
<td>是</td>
<td></td>
<td>enum LDisPlayMode<br/>{<br/>	VIDEO_TILED = 1,		//视频在窗口中平铺显示<br/>	VIDEO_RATIOTILED = 2,	//视频在窗口中等比平铺显示，视频将会被裁减<br/>	VIDEO_RATIO = 3		//视频在窗口中等比显示，周围可能会有黑边<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-184">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h1 id="audiomanager28u97f3u9891u7ba1u7406u7c7b29">AudioManager(音频管理类)</h1>
<p></p>
<h2 id="addaudiocapturecallback0a3ca20id3daddaudiocapturecallback53043e203ca3e">addAudioCaptureCallback
<a id=addAudioCaptureCallback5304> </a></h2>
<p></p>
<h3 id="-185">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p>获取自己音频数据，需要设置回调函数。视频数据格式pcm，码率：8000hz，编码：16bit，声道：2声道</p>
<h3 id="-186">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>IAudioCaptureFun</td>
<td>是</td>
<td></td>
<td>typedef std::function&lt;void(PBYTE, FS_SDK::S_UINT32, FS_SDK::S_INT32)&gt; IAudioCaptureFun;</td>
</tr>
</tbody>
</table>
<h3 id="-187">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="addeventlistener0a3ca20id3daddeventlistener53043e203ca3e">addEventListener
<a id=addEventListener5304> </a></h2>
<p></p>
<h3 id="-188">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_AUDIO_MEDIA_MSG
说明：用户音频状态改变消息

EV_AUDIO_DEVICE_STATE
说明：用户音频设备改变消息
</code></pre>
<h3 id="-189">参数</h3>
<h2 id="removeaudiocapturecallback0a3ca20id3dremoveaudiocapturecallback53043e203ca3e">removeAudioCaptureCallback
<a id=removeAudioCaptureCallback5304> </a></h2>
<p></p>
<h3 id="-190">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p>停止获取音频数据</p>
<h3 id="-191">参数</h3>
<h3 id="-192">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="agreeapplyaudio0a3ca20id3dagreeapplyaudio53043e203ca3e">agreeApplyAudio
<a id=agreeApplyAudio5304> </a></h2>
<p></p>
<h3 id="-193">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p>同意/不同意用户广播音频</p>
<h3 id="-194">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>S_BOOL bAgree</td>
<td>是</td>
<td></td>
<td>TRUE ：同意申请<br/>FALSE：不同意申请</td>
</tr>
</tbody>
</table>
<h3 id="-195">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="getaudioparam0a3ca20id3dgetaudioparam53043e203ca3e">getAudioParam
<a id=getAudioParam5304> </a></h2>
<p></p>
<h3 id="-196">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取默认音频参数
</code></pre>
<h3 id="-197">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>AudioParamKey key</td>
<td>是</td>
<td>audioKey</td>
<td>enum AudioParamKey<br/> {<br/>	AUDIO_VALUE_AEC,				//0X1001	//回音消除(0-1) 0-禁用 1-启用<br/>	AUDIO_VALUE_ANS,				//0X1002	//降噪(0-3) 0-禁用 1-弱 2-中 3-强<br/>	AUDIO_VALUE_VAD,				//0X1003	//静音检测(0-1) 0-禁用 1-启用<br/>	AUDIO_VALUE_AGC,				//0X1004	//自动增益(0-3)0-禁用 1-弱 2-中 3-强<br/>	AUDIO_VALUE_ENCODER,			//0X1005	//采集后使用的编码格式<br/>	AUDIO_VALUE_CAPAUTOVOLUME,         //0X1006	//采集设备音量自动调节(0-1) 0-禁用<br/>};</td>
</tr>
<tr>
<td>S_INT32&amp;</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-198">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setaudioparam0a3ca20id3dsetaudioparam53043e203ca3e">setAudioParam
<a id=setAudioParam5304> </a></h2>
<p></p>
<h3 id="-199">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置音频参数
</code></pre>
<h3 id="-200">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>AudioParamKey  key</td>
<td>是</td>
<td></td>
<td>enum AudioParamKey {<br/>		AUDIO_VALUE_AEC,				//0X1001	//回音消除(0-1)	0-禁用 1-启用<br/>		AUDIO_VALUE_ANS,				//0X1002	//降噪(0-3) 0-禁用 1-弱 2-中 3-强<br/>		AUDIO_VALUE_VAD,				//0X1003	//静音检测(0-1) 0-禁用 1-启用<br/>		AUDIO_VALUE_AGC,				//0X1004	//自动增益(0-3)0-禁用 1-弱 2-中 3-强<br/>		AUDIO_VALUE_ENCODER,			//0X1005	//采集后使用的编码格式<br/>		AUDIO_VALUE_CAPAUTOVOLUME,        //0X1006	//采集设备音量自动调节(0-1) 0-禁用<br/>	};</td>
</tr>
<tr>
<td>S_INT32 value</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-201">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="applybroadcastaudio0a3ca20id3dapplybroadcastaudio53043e203ca3e">applyBroadcastAudio
<a id=applyBroadcastAudio5304> </a></h2>
<p></p>
<h3 id="-202">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地用户申请广播自己的音频，需要拥有权限
</code></pre>
<h3 id="-203">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE： 广播音频<br/>FALSE：停止广播音频</td>
</tr>
</tbody>
</table>
<h3 id="-204">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="broadcastaudio0a3ca20id3dbroadcastaudio53043e203ca3e">broadcastAudio
<a id=broadcastAudio5304> </a></h2>
<p></p>
<h3 id="-205">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>广播\停止广播用户音频，该调用需要拥有权限
触发事件：EV_AUDIO_MEDIA_MSG（用户音频状态改变消息）
</code></pre>
<h3 id="-206">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被操作用户ID</td>
</tr>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE： 广播<br/>FALSE：取消广播</td>
</tr>
</tbody>
</table>
<h3 id="-207">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setallmute0a3ca20id3dsetallmute53043e203ca3e">setAllMute
<a id=setAllMute5304> </a></h2>
<p></p>
<h3 id="-208">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置全场静音，需要权限
</code></pre>
<h3 id="-209">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL  bMuted</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-210">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="getspeakervolume0a3ca20id3dgetspeakervolume53043e203ca3e">getSpeakerVolume
<a id=getSpeakerVolume5304> </a></h2>
<p></p>
<h3 id="-211">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取当前扬声器音量，参数均为输出参数
</code></pre>
<h3 id="-212">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_INT32 *pVolume</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>S_INT32 *pMaxVolume</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>S_INT32 *pMinVolume</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-213">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="getmicrophonedevice0a3ca20id3dgetmicrophonedevice53043e203ca3e">getMicrophoneDevice
<a id=getMicrophoneDevice5304> </a></h2>
<p></p>
<h3 id="-214">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取当前使用的麦克风设备
</code></pre>
<h3 id="-215">参数</h3>
<h3 id="-216">返回数据</h3>
<pre><code class="language-javascript">S_INT32 设备Id
</code></pre>
<h2 id="setspeakerdeviceenable0a3ca20id3dsetspeakerdeviceenable53043e203ca3e">setSpeakerDeviceEnable
<a id=setSpeakerDeviceEnable5304> </a></h2>
<p></p>
<h3 id="-217">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>启用/禁用扬声器
</code></pre>
<h3 id="-218">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL bEnable</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-219">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="setmicrophoneenable0a3ca20id3dsetmicrophoneenable53043e203ca3e">setMicrophoneEnable
<a id=setMicrophoneEnable5304> </a></h2>
<p></p>
<h3 id="-220">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>启用/禁用麦克风。当本地用户正在广播音频，禁用麦克风后其他参会人则听不到本地用户的音频
</code></pre>
<h3 id="-221">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL bEnable</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-222">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="startplayaudio0a3ca20id3dstartplayaudio53043e203ca3e">startPlayAudio
<a id=startPlayAudio5304> </a></h2>
<p></p>
<h3 id="-223">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p>ErrCode</p>
<h3 id="-224">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR  pFilePath</td>
<td>是</td>
<td></td>
<td>播放文件路径</td>
</tr>
</tbody>
</table>
<h2 id="getspeakerdevicelist0a3ca20id3dgetspeakerdevicelist53043e203ca3e">getSpeakerDeviceList
<a id=getSpeakerDeviceList5304> </a></h2>
<p></p>
<h3 id="-225">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p><br data-tomark-pass=""><br>
<br data-tomark-pass=""></p>
<pre><code>获取声音输出设备列表，如耳机，扬声器设备
</code></pre>
<h3 id="-226">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-227">返回数据</h3>
<pre><code class="language-javascript">const AudioDeviceList&amp;
struct AudioChannel
{
	S_BYTE			id = 0;;
	S_BYTE			state = 0;;		//状态
	S_BYTE			is_have_audio = 0;	//
	S_INT32			cap_dev_index = 0;	//索引
	S_INT32			operation = 0;;	//操作 DEV_OPERATION_ADD
	S_UINT32		source_id = 0;		//源
	S_TCHAR			name[256] = { 0 };
};
typedef LVector&lt;AudioChannel&gt;	AudioDeviceList;
</code></pre>
<h2 id="getmicrophonedevicelist0a3ca20id3dgetmicrophonedevicelist53043e203ca3e">getMicrophoneDeviceList
<a id=getMicrophoneDeviceList5304> </a></h2>
<p></p>
<h3 id="-228">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取麦克风设备列表
</code></pre>
<h3 id="-229">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>struct MicDeviceInfo {<br/>	int device_id;            //&lt;设备唯一id，支持热拔插<br/>	String device_name; //&lt;设备名<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-230">返回数据</h3>
<pre><code class="language-javascript">const AudioDeviceList&amp;
struct AudioChannel
{
	S_BYTE			id = 0;;
	S_BYTE			state = 0;;			//状态
	S_BYTE			is_have_audio = 0;	//
	S_INT32			cap_dev_index = 0;	//索引
	S_INT32			operation = 0;;		//操作 DEV_OPERATION_ADD
	S_UINT32		source_id = 0;		//源
	S_TCHAR			name[256] = { 0 };
};
typedef LVector&lt;AudioChannel&gt;	AudioDeviceList;
</code></pre>
<h2 id="setspeakerdevice0a3ca20id3dsetspeakerdevice53043e203ca3e">setSpeakerDevice
<a id=setSpeakerDevice5304> </a></h2>
<p></p>
<h3 id="-231">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置当前音频输出的设备，可以为耳机，或者设备扬声器
</code></pre>
<h3 id="-232">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 nDevIndex</td>
<td>是</td>
<td></td>
<td>设置当前扬声器设备</td>
</tr>
</tbody>
</table>
<h3 id="-233">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setmicrophonedevice0a3ca20id3dsetmicrophonedevice53043e203ca3e">setMicrophoneDevice
<a id=setMicrophoneDevice5304> </a></h2>
<p></p>
<h3 id="-234">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设定当前使用的音频输入麦克风设备，或者耳机麦克风
</code></pre>
<h3 id="-235">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 nDevIndex</td>
<td>是</td>
<td></td>
<td>设置当前麦克风设备</td>
</tr>
</tbody>
</table>
<h3 id="-236">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="getspeakerdevice0a3ca20id3dgetspeakerdevice53043e203ca3e">getSpeakerDevice
<a id=getSpeakerDevice5304> </a></h2>
<p></p>
<h3 id="-237">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取当前使用扬声器设备ID
</code></pre>
<h3 id="-238">参数</h3>
<h3 id="-239">返回数据</h3>
<pre><code class="language-javascript">S_INT32
</code></pre>
<h2 id="stopplayaudio0a3ca20id3dstopplayaudio53043e203ca3e">stopPlayAudio
<a id=stopPlayAudio5304> </a></h2>
<p></p>
<h3 id="-240">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p>停止播放音频</p>
<h3 id="-241">参数</h3>
<h3 id="-242">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setappmute0a3ca20id3dsetappmute53043e203ca3e">setAppMute
<a id=setAppMute5304> </a></h2>
<p></p>
<h3 id="-243">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置本地静音，相当于关闭音频输出。调用之后则本地没有任何声音输出。
</code></pre>
<h3 id="-244">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL bState</td>
<td>是</td>
<td></td>
<td>TRUE ：静音<br/>FALSE：取消静音</td>
</tr>
</tbody>
</table>
<h3 id="-245">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="ismicrophoneenable0a3ca20id3dismicrophoneenable53043e203ca3e">isMicrophoneEnable
<a id=isMicrophoneEnable5304> </a></h2>
<p></p>
<h3 id="-246">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地麦克风是否被禁用
</code></pre>
<h3 id="-247">参数</h3>
<h3 id="-248">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="getmicrophonevolume0a3ca20id3dgetmicrophonevolume53043e203ca3e">getMicrophoneVolume
<a id=getMicrophoneVolume5304> </a></h2>
<p></p>
<h3 id="-249">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取自己麦克风音量，输入音量
</code></pre>
<h3 id="-250">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_INT32*</td>
<td>是</td>
<td>pVolume</td>
<td></td>
</tr>
<tr>
<td>S_INT32*</td>
<td>是</td>
<td>pMaxVolume</td>
<td></td>
</tr>
<tr>
<td>S_INT32*</td>
<td>是</td>
<td>pMinVolume</td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-251">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="getmicrophoneenergy0a3ca20id3dgetmicrophoneenergy53043e203ca3e">getMicrophoneEnergy
<a id=getMicrophoneEnergy5304> </a></h2>
<p></p>
<h3 id="-252">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取麦克风能量值，获取某个参会人音量输入的大小
</code></pre>
<h3 id="-253">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32</td>
<td>是</td>
<td>dwUserID</td>
<td></td>
</tr>
<tr>
<td>S_INT32*</td>
<td>是</td>
<td>pEnergy</td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-254">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="getmicrophoneenergy0a3ca20id3dgetmicrophoneenergy53043e203ca3e-2">getMicrophoneEnergy
<a id=getMicrophoneEnergy5304> </a></h2>
<p></p>
<h3 id="-255">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取自己麦克风能量值
</code></pre>
<h3 id="-256">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_INT32 *pEnergy</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>S_INT32 *pMaxEnergy</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>S_INT32 *pMinEnergy</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-257">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h1 id="wbsharemanager28u767du677fu7ba1u7406u7c7b29">WBShareManager(白板管理类)</h1>
<p></p>
<h2 id="activewb0a3ca20id3dactivewb53083e203ca3e">activeWB
<a id=activeWB5308> </a></h2>
<p></p>
<h3 id="-258">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>激活白板
</code></pre>
<h3 id="-259">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
</tbody>
</table>
<h3 id="-260">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="addeventlistener0a3ca20id3daddeventlistener53083e203ca3e">addEventListener
<a id=addEventListener5308> </a></h2>
<p></p>
<h3 id="-261">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_SHARE_START_WB
说明：开始接受白板

EV_SHARE_STOP_WB
说明：关闭白板
</code></pre>
<h3 id="-262">参数</h3>
<h2 id="addwbpicture0a3ca20id3daddwbpicture53083e203ca3e">addWBPicture
<a id=addWBPicture5308> </a></h2>
<p></p>
<h3 id="-263">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>白板中插入图片
插入的图片不宜太大
</code></pre>
<h3 id="-264">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR file</td>
<td>是</td>
<td></td>
<td>插入图片路径</td>
</tr>
</tbody>
</table>
<h3 id="-265">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="getwbdrawobject0a3ca20id3dgetwbdrawobject53083e203ca3e">getWBDrawObject
<a id=getWBDrawObject5308> </a></h2>
<p></p>
<h3 id="-266">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取绘制方式
</code></pre>
<h3 id="-267">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
</tbody>
</table>
<h3 id="-268">返回数据</h3>
<pre><code class="language-javascript">LWBObjectType
</code></pre>
<h2 id="getwboperate0a3ca20id3dgetwboperate53083e203ca3e">getWBOperate
<a id=getWBOperate5308> </a></h2>
<p></p>
<h3 id="-269">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取操作类型
</code></pre>
<h3 id="-270">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
</tbody>
</table>
<h3 id="-271">返回数据</h3>
<pre><code class="language-javascript">LWBOperate
</code></pre>
<h2 id="getwbstyle0a3ca20id3dgetwbstyle53083e203ca3e">getWBStyle
<a id=getWBStyle5308> </a></h2>
<p></p>
<h3 id="-272">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取风格
</code></pre>
<h3 id="-273">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
<tr>
<td>LWBStyle style</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-274">返回数据</h3>
<pre><code class="language-javascript">DWORD
</code></pre>
<h2 id="getwbtype0a3ca20id3dgetwbtype53083e203ca3e">getWBType
<a id=getWBType5308> </a></h2>
<p></p>
<h3 id="-275">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取白板共享类型，判断是文件白板还是电子白板
</code></pre>
<h3 id="-276">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
</tbody>
</table>
<h3 id="-277">返回数据</h3>
<pre><code class="language-javascript">S_UINT
</code></pre>
<h2 id="savewbfile0a3ca20id3dsavewbfile53083e203ca3e">saveWBFile
<a id=saveWBFile5308> </a></h2>
<p></p>
<h3 id="-278">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>保存白板文件
</code></pre>
<h3 id="-279">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>保存的白板索引值</td>
</tr>
<tr>
<td>S_PWCHAR file</td>
<td>是</td>
<td></td>
<td>保存的文件完整路径</td>
</tr>
</tbody>
</table>
<h3 id="-280">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setrotatewb0a3ca20id3dsetrotatewb53083e203ca3e">setRotateWB
<a id=setRotateWB5308> </a></h2>
<p></p>
<h3 id="-281">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>旋转白板
</code></pre>
<h3 id="-282">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
<tr>
<td>S_BOOL state</td>
<td>是</td>
<td></td>
<td>TRUE ：顺时针旋转<br/>FALSE：逆时针旋转</td>
</tr>
</tbody>
</table>
<h3 id="-283">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setwbbkcolor0a3ca20id3dsetwbbkcolor53083e203ca3e">setWBBkColor
<a id=setWBBkColor5308> </a></h2>
<p></p>
<h3 id="-284">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p>设置背景色</p>
<h3 id="-285">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
<tr>
<td>S_INT color</td>
<td>是</td>
<td></td>
<td>颜色</td>
</tr>
</tbody>
</table>
<h3 id="-286">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setwbcurzoom0a3ca20id3dsetwbcurzoom53083e203ca3e">setWBCurZoom
<a id=setWBCurZoom5308> </a></h2>
<p></p>
<h3 id="-287">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置缩放比例
</code></pre>
<h3 id="-288">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
<tr>
<td>S_INT nZoom</td>
<td>是</td>
<td></td>
<td>缩放比例</td>
</tr>
</tbody>
</table>
<h3 id="-289">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setwbdrawobject0a3ca20id3dsetwbdrawobject53083e203ca3e">setWBDrawObject
<a id=setWBDrawObject5308> </a></h2>
<p></p>
<h3 id="-290">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置绘制方式
</code></pre>
<h3 id="-291">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
<tr>
<td>LWBObjectType drawType</td>
<td>是</td>
<td></td>
<td>enum LWBObjectType<br/>{<br/>	WB_OBJECT_TYPE_EMPTY = 0,	//空<br/>	WB_OBJECT_TYPE_BEELINE,		//直线,线类型<br/>	WB_OBJECT_TYPE_ARROW,		//箭头<br/>	WB_OBJECT_TYPE_PENCIL,		//铅笔<br/>	WB_OBJECT_TYPE_MASKPENCIL,	//荧光笔<br/>	WB_OBJECT_TYPE_RECT,		//矩形<br/>	WB_OBJECT_TYPE_ROUNDRECT,	//圆角矩形<br/>	WB_OBJECT_TYPE_ELLIPSE,		//圆形<br/>	WB_OBJECT_TYPE_TEXT,		//文字<br/>	WB_OBJECT_TYPE_HAND,		//手<br/>	WB_OBJECT_TYPE_PIC,			//图片<br/>	WB_OBJECT_TYPE_POINT,		//点<br/>	WB_OBJECT_TYPE_LINE,		//线<br/>	WB_OBJECT_TYPE_PLANE		//面<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-292">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setwboperate0a3ca20id3dsetwboperate53083e203ca3e">setWBOperate
<a id=setWBOperate5308> </a></h2>
<p></p>
<h3 id="-293">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置操作类型
</code></pre>
<h3 id="-294">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
<tr>
<td>LWBOperate op</td>
<td>是</td>
<td></td>
<td>操作类型<br/>enum LWBOperate<br/>{<br/>	DRAW,	//画      0<br/>	SELECT,	//选择    1<br/>	HAND,	//拖动    2<br/>	ERASE	//删除    3<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-295">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setwbstyle0a3ca20id3dsetwbstyle53083e203ca3e">setWBStyle
<a id=setWBStyle5308> </a></h2>
<p></p>
<h3 id="-296">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置风格
</code></pre>
<h3 id="-297">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT index</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
<tr>
<td>LWBStyle style</td>
<td>是</td>
<td></td>
<td>enum LWBStyle<br/>{<br/>	WB_LINE_WIDTH,    //线宽<br/>	WB_LINE_TYPE,       //划线类型<br/>	WB_LINE_COLOR,   //划线颜色<br/>	WB_FILL_COLOR,    //填充颜色<br/>	WB_FILL_MODE,     //填充模式<br/>	WB_FILL_STYLE,      //填充风格<br/>};</td>
</tr>
<tr>
<td>DWORD value</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-298">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="startwbshare0a3ca20id3dstartwbshare53083e203ca3e">startWBShare
<a id=startWBShare5308> </a></h2>
<p></p>
<h3 id="-299">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>开始共享电子白板，主要功能是请求权限相关操作，服务器权限校验通过后会触发事件，该事件中用户可以开始广播共享的电子文档。
</code></pre>
<h3 id="-300">参数</h3>
<h3 id="-301">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="stopwbshare0a3ca20id3dstopwbshare53083e203ca3e">stopWBShare
<a id=stopWBShare5308> </a></h2>
<p></p>
<h3 id="-302">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>停止自己或者他人共享的白板，需要拥有权限
</code></pre>
<h3 id="-303">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>被关闭文档的创建者ID</td>
</tr>
<tr>
<td>S_UINT32 dwIndex</td>
<td>是</td>
<td></td>
<td>被关闭文档索引号，该数据从EV_SHARE_WB事件中返回</td>
</tr>
</tbody>
</table>
<h3 id="-304">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="startremotewbshareview0a3ca20id3dstartremotewbshareview53083e203ca3e">startRemoteWBShareView
<a id=startRemoteWBShareView5308> </a></h2>
<p></p>
<h3 id="-305">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>开始接收他人共享的白板或者开始广播自己共享的白板，在接收到EV_SHARE_WB事件后调用。
</code></pre>
<h3 id="-306">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwIndex</td>
<td>是</td>
<td></td>
<td>白板索引值</td>
</tr>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>白板共享者用户ID</td>
</tr>
<tr>
<td>HWND hwnd</td>
<td>是</td>
<td></td>
<td>接受白板的显示窗口句柄</td>
</tr>
</tbody>
</table>
<h3 id="-307">返回数据</h3>
<pre><code class="language-javascript">S_UINT32  成功返回共享白板的白板ID，失败返回0
</code></pre>
<h1 id="screensharemanager28u5c4fu5e55u5171u4eabu7ba1u7406u7c7b29">ScreenShareManager(屏幕共享管理类)</h1>
<p></p>
<h2 id="isscreensharing0a3ca20id3disscreensharing53123e203ca3e">isScreenSharing
<a id=isScreenSharing5312> </a></h2>
<p></p>
<h3 id="-308">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>是否正在屏幕共享
</code></pre>
<h3 id="-309">参数</h3>
<h3 id="-310">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="addeventlistener0a3ca20id3daddeventlistener53123e203ca3e">addEventListener
<a id=addEventListener5312> </a></h2>
<p></p>
<h3 id="-311">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_SHARE_SCREEN
说明：屏幕共享消息通知

EV_SHARE_MULTI_STATE
说明：设置多人共享模式，失败类型：ERR_FAIL，可以调用强制设置
</code></pre>
<h3 id="-312">参数</h3>
<h2 id="startremotescreenshareview0a3ca20id3dstartremotescreenshareview53123e203ca3e">startRemoteScreenShareView
<a id=startRemoteScreenShareView5312> </a></h2>
<p></p>
<h3 id="-313">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>开始接收渲染远端的屏幕共享，参数由来源于屏幕共享监听事件
</code></pre>
<h3 id="-314">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>S_BYTE audioChannel</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>HWND hwnd</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-315">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="stopremotescreenshareview0a3ca20id3dstopremotescreenshareview53123e203ca3e">stopRemoteScreenShareView
<a id=stopRemoteScreenShareView5312> </a></h2>
<p></p>
<h3 id="-316">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>停止接收渲染远端屏幕共享
</code></pre>
<h3 id="-317">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>S_BYTE audioChannel</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<h3 id="-318">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="startscreenshare0a3ca20id3dstartscreenshare53123e203ca3e">startScreenShare
<a id=startScreenShare5312> </a></h2>
<p></p>
<h3 id="-319">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>本地用户发起屏幕共享，远端用户收到消息后，即可调用starRemoteScreenShareView来进行渲染显示
</code></pre>
<h3 id="-320">参数</h3>
<h3 id="-321">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="stopscreenshare0a3ca20id3dstopscreenshare53123e203ca3e">stopScreenShare
<a id=stopScreenShare5312> </a></h2>
<p></p>
<h3 id="-322">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>停止自己或他人屏幕共享，需要权限
</code></pre>
<h3 id="-323">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>停止共享的用户的ID</td>
</tr>
</tbody>
</table>
<h3 id="-324">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setscreensharequalitybias0a3ca20id3dsetscreensharequalitybias53123e203ca3e">setScreenShareQualityBias
<a id=setScreenShareQualityBias5312> </a></h2>
<p></p>
<h3 id="-325">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设备屏幕共享视频质量模式
</code></pre>
<h3 id="-326">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>ScreenShareQualityBias</td>
<td>是</td>
<td></td>
<td>enum ScreenShareQualityBias<br/>{<br/>	SCREEN_SHARE_BIAS_QUALITY = 0, //&lt;偏重画面质量，适合共享文档等静态桌面<br/>	SCREEN_SHARE_BIAS_SPEED = 1     //&lt;偏重帧率速度，适合视频等动态桌面<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-327">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="setscreensharevoice0a3ca20id3dsetscreensharevoice53123e203ca3e">setScreenShareVoice
<a id=setScreenShareVoice5312> </a></h2>
<p></p>
<h3 id="-328">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置屏幕共享声音
</code></pre>
<h3 id="-329">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL</td>
<td>是</td>
<td></td>
<td>状态开关</td>
</tr>
</tbody>
</table>
<h3 id="-330">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="updatescreensharewnd0a3ca20id3dupdatescreensharewnd53123e203ca3e">updateScreenShareWnd
<a id=updateScreenShareWnd5312> </a></h2>
<p></p>
<h3 id="-331">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>接受其他人共享屏幕的的状态下，刷新接收界面大小，例如：放大共享区域、缩小共享区域。建议接收屏幕共享的窗口大小改变时调用。
</code></pre>
<h3 id="-332">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>HWND</td>
<td>是</td>
<td></td>
<td>窗口句柄</td>
</tr>
</tbody>
</table>
<h3 id="-333">返回数据</h3>
<pre><code class="language-javascript">{&quot;type&quot;:&quot;object&quot;,&quot;title&quot;:&quot;title&quot;,&quot;properties&quot;:{}}
</code></pre>
<h2 id="ismultishareenable0a3ca20id3dismultishareenable53123e203ca3e">isMultiShareEnable
<a id=isMultiShareEnable5312> </a></h2>
<p></p>
<h3 id="-334">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>当前会议是否是多人共享模式
</code></pre>
<h3 id="-335">参数</h3>
<h3 id="-336">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h2 id="setmultishareenable0a3ca20id3dsetmultishareenable53123e203ca3e">setMultiShareEnable
<a id=setMultiShareEnable5312> </a></h2>
<p></p>
<h3 id="-337">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置会议多人共享模式，普通设置失败可以调用强制设置
</code></pre>
<h3 id="-338">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL</td>
<td>是</td>
<td></td>
<td>TRUE   多人共享<br/>FALSE  单人共享</td>
</tr>
<tr>
<td>S_BOOL</td>
<td>是</td>
<td></td>
<td>TRUE   强制设置<br/>FALSE  普通设置</td>
</tr>
</tbody>
</table>
<h3 id="-339">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="getcurrentdatasharecount0a3ca20id3dgetcurrentdatasharecount53123e203ca3e">getCurrentDataShareCount
<a id=getCurrentDataShareCount5312> </a></h2>
<p></p>
<h3 id="-340">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取当前已经共享的个数
</code></pre>
<h3 id="-341">参数</h3>
<h3 id="-342">返回数据</h3>
<pre><code class="language-javascript">S_UINT
</code></pre>
<h1 id="chatmanager28u804au5929u7ba1u7406u7c7b29">ChatManager(聊天管理类)</h1>
<p></p>
<h2 id="addeventlistener0a3ca20id3daddeventlistener53163e203ca3e">addEventListener
<a id=addEventListener5316> </a></h2>
<p></p>
<h3 id="-343">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_CHAT_MSG
说明：聊天消息通知
</code></pre>
<h3 id="-344">参数</h3>
<h2 id="sendchatmessage0a3ca20id3dsendchatmessage53163e203ca3e">sendChatMessage
<a id=sendChatMessage5316> </a></h2>
<p></p>
<h3 id="-345">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>向当前会议室中发送聊天消息，dwUserID 若传入用户id则指定用户收到聊天消息，若传入0则所有参会人都能收到聊天消息
</code></pre>
<h3 id="-346">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 dwUserID</td>
<td>是</td>
<td></td>
<td>目标用户，0表示对全部人</td>
</tr>
<tr>
<td>S_PWCHAR pMsg</td>
<td>是</td>
<td></td>
<td>消息内容</td>
</tr>
</tbody>
</table>
<h1 id="permissionmanager28u6743u9650u7ba1u7406u7c7b29">PermissionManager(权限管理类)</h1>
<p></p>
<h2 id="configroompermission0a3ca20id3dconfigroompermission53203e203ca3e">configRoomPermission
<a id=configRoomPermission5320> </a></h2>
<p></p>
<h3 id="-347">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>设置会议室全局权限接口
</code></pre>
<h3 id="-348">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>LPERMISSION  enType</td>
<td>是</td>
<td></td>
<td>权限<br/>enum LROOM_PERMISSION<br/>{<br/>	ROOM_BROADCAST_AUDIO,				//自我解除静音<br/>	ROOM_BROADCAST_VIDEO,				//自我开启视频<br/>	ROOM_SHARE_SCREEN,					//共享桌面<br/>	ROOM_SHARE_MEDIA,					//共享媒体<br/>	ROOM_SHARE_CREATE_WB,				//共享白板<br/>	ROOM_SHARE_WRITE_WB,				//标注白板<br/>	ROOM_SHARE_SAVE_WB,				//保存白板<br/>        ROOM_LOCAL_RECORD,					//本地录制<br/>	ROOM_SHARE_PAGE_TRUN_WB,			//文档翻页<br/>	ROOM_PUBLIC_CHAT,					//文字群聊<br/>	ROOM_PRIVATE_CHAT,					//文字私聊<br/>};</td>
</tr>
<tr>
<td>LROLE role</td>
<td>是</td>
<td></td>
<td>拥有权限的角色<br/>enum LROLE<br/>{<br/>	ROLE_NONE,		    //None<br/>	ROLE_ALL,		    //所有人<br/>	ROLE_MANAGER_HOST,  //管理员+主持人<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-349">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="checkroompermission0a3ca20id3dcheckroompermission53203e203ca3e">checkRoomPermission
<a id=checkRoomPermission5320> </a></h2>
<p></p>
<h3 id="-350">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p><span class="colour" style="color:rgb(85, 85, 85)"></span></p>
<pre><code>查询会议室全局权限状态接口
</code></pre>
<h3 id="-351">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>LROOM_PERMISSION enType</td>
<td>是</td>
<td></td>
<td>权限<br/>enum LROOM_PERMISSION<br/>{<br/>	ROOM_BROADCAST_AUDIO,				//自我解除静音<br/>	ROOM_BROADCAST_VIDEO,				//自我开启视频<br/>	ROOM_SHARE_SCREEN,					//共享桌面<br/>	ROOM_SHARE_MEDIA,					//共享媒体<br/>	ROOM_SHARE_CREATE_WB,				//共享白板<br/>	ROOM_SHARE_WRITE_WB,				//标注白板<br/>	ROOM_SHARE_SAVE_WB,				//保存白板<br/>        ROOM_LOCAL_RECORD,					//本地录制<br/>	ROOM_SHARE_PAGE_TRUN_WB,			//文档翻页<br/>	ROOM_PUBLIC_CHAT,					//文字群聊<br/>	ROOM_PRIVATE_CHAT,					//文字私聊<br/>};</td>
</tr>
</tbody>
</table>
<h3 id="-352">返回数据</h3>
<pre><code class="language-javascript">LROLE
enum LROLE
{
	ROLE_NONE,		  //None
	ROLE_ALL,		  //所有人
	ROLE_MANAGER_HOST,  //管理员+主持人
};
</code></pre>
<h2 id="configuserpermission0a3ca20id3dconfiguserpermission53203e203ca3e">configUserPermission
<a id=configUserPermission5320> </a></h2>
<p></p>
<h3 id="-353">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>配置用户权限接口
</code></pre>
<h3 id="-354">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>LUSER_PERMISSION  enType</td>
<td>是</td>
<td></td>
<td>权限<br/>enum LUSER_PERMISSION<br/>{<br/>	USER_PERMISSION_DEFAULT,<br/>	CAN_AUDIO_APPLY_BROADCAST,			//允许申请广播自己音频<br/>	CAN_AUDIO_BROADCAST_OWN,			//允许广播/停止自己音频<br/>	CAN_AUDIO_BROADCAST_OTHERS,		//允许广播/停止他人音频<br/>	CAN_AUDIO_CAN_BE_BROADCASTED,		//允许音频被广播<br/>	CAN_AUDIO_CONFIG_PARAM,			//允许配置他人的音视频参数<br/>	CAN_AUDIO_MUTE_OTHER,				//允许打开/关闭他人音频输出功能<br/><br/>	CAN_VIDEO_APPLY_BROADCAST,			//允许申请广播自己视频<br/>	CAN_VIDEO_BROADCAST_OWN,                    //允许广播自己的视频<br/>	CAN_VIDEO_BROADCAST_OTHERS,		//允许广播/停止广播他人视频<br/>	CAN_VIDEO_VIEW_OTHERS,				//允许查看/停止查看未广播的他人视频<br/>	CAN_VIDEO_CAN_BE_BROADCASTED,		//允许视频被广播/查看<br/><br/>	CAN_USER_APPLY_HOST,				//允许申请主持人<br/>	CAN_USER_CONFIG_OTHERS_HOST,		//允许授予/审批他人成为主讲人<br/><br/>	CAN_USER_APPLY_MANAGER,			//允许申请管理员<br/>	CAN_USER_CONFIG_OTHERS_MANAGER,	//允许授予他人管理员<br/><br/>	CAN_SHARE_SCREEN,                   //允许拥有屏幕共享功能<br/>	CAN_SHARE_CONFIG_SCREEN,			//允许配置他人共享桌面<br/>	CAN_SHARE_CLOSE_OTHER_APP,			//允许关闭他人共享<br/>	CAN_SHARE_WB_APPLY,					//允许申请白板共享<br/>	CAN_SHARE_WB_CONFIG_OTHERS,		//允许配置他人共享白板<br/>	CAN_SHARE_WB_MARK,					//允许白板标注权限<br/>	CAN_SHARE_WB_CONFIG_OTHERS_MARK,	//允许配置他人白板标注<br/>	CAN_SHARE_WB_SAVE,					//允许保存白板权限<br/>	CAN_SHARE_WB_TURN_PAGE,			//允许白板翻页权限<br/>	CAN_SHARE_WB_CLOSE_OTHER,			//允许关闭他人白板权限<br/><br/>	CAN_CONFIG_BROADCAST_LAYOUT,		//允许授予自己/他人广播布局 <br/>	CAN_BROADCAST_LAYOUT,				//允许广播布局 <br/><br/>	CAN_PUBLIC_CHAT,					//允许文字公聊权限<br/>	CAN_CONFIG_OTHERS_PUBLIC_CHAT,           //允许授予/取消他人文字公聊权限<br/>	CAN_PRIVATE_CHAT,					//允许文字私聊权限<br/>	CAN_CONFIG_OTHERS_PRIVATE_CHAT,          //允许授予/取消他人文字私聊权限<br/><br/>	CAN_MODIFY_OTHERS_USER_INFO,               //允许修改他人信息<br/>	CAN_MODIFY_OWN_USER_INFO,                   //允许修改自己信息<br/>	CAN_SEE_OTHER_INFO,					//允许查看他人用户信息<br/>	CAN_MEETING_ALL_MUTE,				//允许全场静音<br/>	CAN_MEETING_LOCK,					//允许锁定会议室<br/>	CAN_MEETING_CLOSE,					//允许关闭会议室<br/>	CAN_MEETING_KICK,					//允许踢人<br/>	CAN_SHARE_MEDIA,					//允许共享媒体<br/>	CAN_SHARE_CONFIG_MEDIA,			//允许配置他人共享媒体<br/>};</td>
</tr>
<tr>
<td>S_BOOL bEnable</td>
<td>否</td>
<td></td>
<td>TRUE： 设置权限<br/>FALSE：取消权限</td>
</tr>
<tr>
<td>S_UINT32 dwUserID</td>
<td>否</td>
<td></td>
<td>操作自己可以不传</td>
</tr>
</tbody>
</table>
<h3 id="-355">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="checkuserpermission0a3ca20id3dcheckuserpermission53203e203ca3e">checkUserPermission
<a id=checkUserPermission5320> </a></h2>
<p></p>
<h3 id="-356">基本信息</h3>


<p><strong>接口描述：</strong></p>
<p>查询用户权限状态接口，查询类型见枚举定义</p>
<h3 id="-357">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>LUSER_PERMISSION enType</td>
<td>是</td>
<td></td>
<td>权限<br/>enum LUSER_PERMISSION<br/>{<br/>	USER_PERMISSION_DEFAULT,<br/>	CAN_AUDIO_APPLY_BROADCAST,			//允许申请广播自己音频<br/>	CAN_AUDIO_BROADCAST_OWN,			//允许广播/停止自己音频<br/>	CAN_AUDIO_BROADCAST_OTHERS,		//允许广播/停止他人音频<br/>	CAN_AUDIO_CAN_BE_BROADCASTED,		//允许音频被广播<br/>	CAN_AUDIO_CONFIG_PARAM,			//允许配置他人的音视频参数<br/>	CAN_AUDIO_MUTE_OTHER,				//允许打开/关闭他人音频输出功能<br/><br/>	CAN_VIDEO_APPLY_BROADCAST,			//允许申请广播自己视频<br/>	CAN_VIDEO_BROADCAST_OWN,                    //允许广播自己的视频<br/>	CAN_VIDEO_BROADCAST_OTHERS,		//允许广播/停止广播他人视频<br/>	CAN_VIDEO_VIEW_OTHERS,				//允许查看/停止查看未广播的他人视频<br/>	CAN_VIDEO_CAN_BE_BROADCASTED,		//允许视频被广播/查看<br/><br/>	CAN_USER_APPLY_HOST,				//允许申请主持人<br/>	CAN_USER_CONFIG_OTHERS_HOST,		//允许授予/审批他人成为主讲人<br/><br/>	CAN_USER_APPLY_MANAGER,			//允许申请管理员<br/>	CAN_USER_CONFIG_OTHERS_MANAGER,	//允许授予他人管理员<br/><br/>	CAN_SHARE_SCREEN,                   //允许拥有屏幕共享功能<br/>	CAN_SHARE_CONFIG_SCREEN,			//允许配置他人共享桌面<br/>	CAN_SHARE_CLOSE_OTHER_APP,			//允许关闭他人共享<br/>	CAN_SHARE_WB_APPLY,					//允许申请白板共享<br/>	CAN_SHARE_WB_CONFIG_OTHERS,		//允许配置他人共享白板<br/>	CAN_SHARE_WB_MARK,					//允许白板标注权限<br/>	CAN_SHARE_WB_CONFIG_OTHERS_MARK,	//允许配置他人白板标注<br/>	CAN_SHARE_WB_SAVE,					//允许保存白板权限<br/>	CAN_SHARE_WB_TURN_PAGE,			//允许白板翻页权限<br/>	CAN_SHARE_WB_CLOSE_OTHER,			//允许关闭他人白板权限<br/><br/>	CAN_CONFIG_BROADCAST_LAYOUT,		//允许授予自己/他人广播布局 <br/>	CAN_BROADCAST_LAYOUT,				//允许广播布局 <br/><br/>	CAN_PUBLIC_CHAT,					//允许文字公聊权限<br/>	CAN_CONFIG_OTHERS_PUBLIC_CHAT,           //允许授予/取消他人文字公聊权限<br/>	CAN_PRIVATE_CHAT,					//允许文字私聊权限<br/>	CAN_CONFIG_OTHERS_PRIVATE_CHAT,          //允许授予/取消他人文字私聊权限<br/><br/>	CAN_MODIFY_OTHERS_USER_INFO,               //允许修改他人信息<br/>	CAN_MODIFY_OWN_USER_INFO,                   //允许修改自己信息<br/>	CAN_SEE_OTHER_INFO,					//允许查看他人用户信息<br/>	CAN_MEETING_ALL_MUTE,				//允许全场静音<br/>	CAN_MEETING_LOCK,					//允许锁定会议室<br/>	CAN_MEETING_CLOSE,					//允许关闭会议室<br/>	CAN_MEETING_KICK,					//允许踢人<br/>	CAN_SHARE_MEDIA,					//允许共享媒体<br/>	CAN_SHARE_CONFIG_MEDIA,			//允许配置他人共享媒体<br/>};</td>
</tr>
<tr>
<td>S_UINT32 dwUserID</td>
<td>否</td>
<td></td>
<td>查询自己可以不传</td>
</tr>
</tbody>
</table>
<h3 id="-358">返回数据</h3>
<pre><code class="language-javascript">S_BOOL
</code></pre>
<h1 id="roomlistmanager28u4f1au8baeu5217u8868u7ba1u7406u7c7b29">RoomListManager(会议列表管理类)</h1>
<p></p>
<h2 id="addeventlistener0a3ca20id3daddeventlistener53243e203ca3e">addEventListener
<a id=addEventListener5324> </a></h2>
<p></p>
<h3 id="-359">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>EV_FRONT_ROOM_COMMON_LIST
说明：固定会议室列表结果事件

EV_FRONT_ROOM_SCHEDUL_LIST
说明：预约会议室列表结果事件

EV_FRONT_ROOM_INSTANT_LIST
说明：即时会议室列表结果事件
</code></pre>
<h3 id="-360">参数</h3>
<p><strong>Headers</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数值</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>Content-Type</td>
<td>application/x-www-form-urlencoded</td>
<td>是</td>
<td></td>
<td></td>
</tr>
</tbody>
</table>
<p><strong>Body</strong></p>
<table>
<thead>
<tr>
<th>参数名称</th>
<th>参数类型</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>SNOTIFY</td>
<td>text</td>
<td>是</td>
<td></td>
<td>监听回调函数</td>
</tr>
</tbody>
</table>
<h2 id="querycommonmeeting0a3ca20id3dquerycommonmeeting53243e203ca3e">queryCommonMeeting
<a id=queryCommonMeeting5324> </a></h2>
<p></p>
<h3 id="-361">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取固定会议室列表
返回结果从EV_FRONT_ROOM_COMMON_LIST事件中获取
</code></pre>
<h3 id="-362">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR pszSearchKey</td>
<td>是</td>
<td></td>
<td>搜索会议室名称关键字，查所有的传空字符串</td>
</tr>
<tr>
<td>S_UINT32 curPage</td>
<td>是</td>
<td></td>
<td>获取会议室列表页面索引值</td>
</tr>
<tr>
<td>S_UINT32 pageSize</td>
<td>否</td>
<td></td>
<td>默认值30，可以不传</td>
</tr>
</tbody>
</table>
<h3 id="-363">返回数据</h3>
<pre><code class="language-javascript">ErrCode

</code></pre>
<h2 id="queryschedulmeeting0a3ca20id3dqueryschedulmeeting53243e203ca3e">querySchedulMeeting
<a id=querySchedulMeeting5324> </a></h2>
<p></p>
<h3 id="-364">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取预约会议室列表

返回结果从EV_FRONT_ROOM_SCHEDUL_LIST事件中获取
</code></pre>
<h3 id="-365">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR pszSearchKey</td>
<td>是</td>
<td></td>
<td>搜索会议室名称关键字，查所有的传空字符串</td>
</tr>
<tr>
<td>S_UINT32 nRecentDays</td>
<td>是</td>
<td></td>
<td></td>
</tr>
<tr>
<td>S_UINT32 curPage</td>
<td>是</td>
<td></td>
<td>获取会议室列表页面索引值</td>
</tr>
<tr>
<td>S_UINT32 pageSize</td>
<td>是</td>
<td></td>
<td>默认值30，可以不传</td>
</tr>
</tbody>
</table>
<h3 id="-366">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="queryinstantmeeting0a3ca20id3dqueryinstantmeeting53243e203ca3e">queryInstantMeeting
<a id=queryInstantMeeting5324> </a></h2>
<p></p>
<h3 id="-367">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取即时会议室列表

返回结果从EV_FRONT_ROOM_INSTANT_LIST事件中获取
</code></pre>
<h3 id="-368">参数</h3>
<h3 id="-369">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="createinstantmeeting0a3ca20id3dcreateinstantmeeting53243e203ca3e">createInstantMeeting
<a id=createInstantMeeting5324> </a></h2>
<p></p>
<h3 id="-370">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>创建即时会议室

返回结果从EV_FRONT_ROOM_SCHEDUL_LIST事件中获取
</code></pre>
<h3 id="-371">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_PWCHAR pszMeetingName</td>
<td>是</td>
<td></td>
<td>会议室名称</td>
</tr>
<tr>
<td>S_PWCHAR pszMeetingPwd</td>
<td>是</td>
<td></td>
<td>会议室密码，不需要传空</td>
</tr>
<tr>
<td>S_PWCHAR pszAdminPwd</td>
<td>是</td>
<td></td>
<td>会议室管理员密码，不需要传空</td>
</tr>
<tr>
<td>S_UINT32* userList</td>
<td>是</td>
<td></td>
<td>授权用户列表</td>
</tr>
<tr>
<td>S_UINT32 nSize</td>
<td>是</td>
<td></td>
<td>授权人数</td>
</tr>
</tbody>
</table>
<h3 id="-372">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h1 id="contactmanager28u901au8bafu5f55u7ba1u7406u7c7b29">ContactManager(通讯录管理类)</h1>
<p></p>
<h2 id="acceptinvite0a3ca20id3dacceptinvite53283e203ca3e">acceptInvite
<a id=acceptInvite5328> </a></h2>
<p></p>
<h3 id="-373">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>接受/拒绝邀请
</code></pre>
<h3 id="-374">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL accept</td>
<td>是</td>
<td></td>
<td>是否接受</td>
</tr>
</tbody>
</table>
<h3 id="-375">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="inviteuser0a3ca20id3dinviteuser53283e203ca3e">inviteUser
<a id=inviteUser5328> </a></h2>
<p></p>
<h3 id="-376">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>邀请通讯录在线用户

返回结果从EV_FRONT_INVITE_ACCEPTED事件中获取
</code></pre>
<h3 id="-377">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32* userList</td>
<td>是</td>
<td></td>
<td>受邀用户列表数组</td>
</tr>
<tr>
<td>S_UINT32 nSize</td>
<td>是</td>
<td></td>
<td>受邀用户数量</td>
</tr>
<tr>
<td>S_PWCHAR pszMeetingName</td>
<td>否</td>
<td></td>
<td>会议名称（用于会前创建即时会议）</td>
</tr>
<tr>
<td>S_PWCHAR pszMeetingPwd</td>
<td>否</td>
<td></td>
<td>会议密码（用于会前创建即时会议）</td>
</tr>
<tr>
<td>S_PWCHAR pszAdminPwd</td>
<td>否</td>
<td></td>
<td>管理员密码（用于会前创建即时会议）</td>
</tr>
</tbody>
</table>
<h3 id="-378">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="querydeptinfo0a3ca20id3dquerydeptinfo53283e203ca3e">queryDeptInfo
<a id=queryDeptInfo5328> </a></h2>
<p></p>
<h3 id="-379">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取组织架构信息

返回结果从EV_FRONT_DEPT_INFO事件中获取
</code></pre>
<h3 id="-380">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_BOOL refresh</td>
<td>是</td>
<td></td>
<td>是否刷新缓存数据</td>
</tr>
</tbody>
</table>
<h3 id="-381">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h2 id="querydeptuser0a3ca20id3dquerydeptuser53283e203ca3e">queryDeptUser
<a id=queryDeptUser5328> </a></h2>
<p></p>
<h3 id="-382">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>获取部门用户

返回结果从EV_FRONT_DEPT_USER事件中获取
</code></pre>
<h3 id="-383">参数</h3>

<table>
<thead>
<tr>
<th>参数名称</th>
<th>是否必须</th>
<th>示例</th>
<th>备注</th>
</tr>
</thead>
<tbody>
<tr>
<td>S_UINT32 deptId</td>
<td>是</td>
<td></td>
<td>部门ID</td>
</tr>
</tbody>
</table>
<h3 id="-384">返回数据</h3>
<pre><code class="language-javascript">ErrCode
</code></pre>
<h1 id="u5173u952eu7c7bu578bu5b9au4e49">关键类型定义</h1>
<p></p>
<h2 id="errcode0a3ca20id3derrcode53323e203ca3e">ErrCode
<a id=ErrCode5332> </a></h2>
<p></p>
<h3 id="-385">基本信息</h3>


<p><strong>接口描述：</strong></p>
<table>
<thead>
<tr>
<th>错误码名</th>
<th>错误码值</th>
<th>错误描述</th>
<th>建议处理</th>
</tr>
</thead>
<tbody>
<tr>
<td>ERR_UNKNOW,</td>
<td></td>
<td>未知错误</td>
<td></td>
</tr>
<tr>
<td>ERR_SUCCESS</td>
<td></td>
<td>成功</td>
<td></td>
</tr>
<tr>
<td>ERR_NETWORK</td>
<td></td>
<td>网络错误</td>
<td></td>
</tr>
<tr>
<td>ERR_INVALID_PARAM</td>
<td></td>
<td>参数异常，用于登录参数验证</td>
<td></td>
</tr>
<tr>
<td>ERR_IN_LOGINING</td>
<td></td>
<td>正在登录会议室，防止多次调用登录会议室</td>
<td></td>
</tr>
<tr>
<td>ERR_LOGIN_TIMEOUT</td>
<td></td>
<td>登录超时</td>
<td></td>
</tr>
<tr>
<td>ERR_ACCOUT_PWD</td>
<td></td>
<td>账户名或密码错误</td>
<td></td>
</tr>
<tr>
<td>ERR_ACCOUT_LOCK</td>
<td></td>
<td>账户被锁</td>
<td></td>
</tr>
<tr>
<td>ERR_ACCOUT_BAN</td>
<td></td>
<td>账户被禁用</td>
<td></td>
</tr>
<tr>
<td>ERR_CONNECT_SERVER_ERR</td>
<td></td>
<td>连接服务器失败</td>
<td></td>
</tr>
<tr>
<td>ERR_LOGIN_SUCCESS</td>
<td></td>
<td>登录成功</td>
<td></td>
</tr>
<tr>
<td>ERR_LOGIN_FAILED</td>
<td></td>
<td>登录失败</td>
<td></td>
</tr>
<tr>
<td>ERR_ADMIN_PWD_ERR</td>
<td></td>
<td>管理员密码错误</td>
<td></td>
</tr>
<tr>
<td>ERR_ADMIN_ERR</td>
<td></td>
<td>申请管理员失败</td>
<td></td>
</tr>
<tr>
<td>ERR_IN_MEETING</td>
<td></td>
<td>用户已经在会议室中</td>
<td></td>
</tr>
<tr>
<td>ERR_VERIFY_ROOM</td>
<td></td>
<td>会议室校验错误</td>
<td></td>
</tr>
<tr>
<td>ERR_ROOM_PWD</td>
<td></td>
<td>会议室密码错误</td>
<td></td>
</tr>
<tr>
<td>ERR_INVALID_STATE</td>
<td></td>
<td>非法状态</td>
<td></td>
</tr>
<tr>
<td>ERR_OUTOF_MEMORY</td>
<td></td>
<td>内存不足</td>
<td></td>
</tr>
<tr>
<td>ERR_DEVICE_FAIL</td>
<td></td>
<td>访问设备失败</td>
<td></td>
</tr>
<tr>
<td>ERR_CONNECT_FAIL</td>
<td></td>
<td>网络连接失败</td>
<td></td>
</tr>
<tr>
<td>ERR_TOKEN_INVALID</td>
<td></td>
<td>认证失败</td>
<td></td>
</tr>
<tr>
<td>ERR_NOT_LOGIN</td>
<td></td>
<td>没有登录</td>
<td></td>
</tr>
<tr>
<td>ERR_NO_VIDEO_PRIVILEGE</td>
<td></td>
<td>没有视频权限</td>
<td></td>
</tr>
<tr>
<td>ERR_NO_AUDIO_PRIVILEGE</td>
<td></td>
<td>没有音频权限</td>
<td></td>
</tr>
<tr>
<td>ERR_NO_ADMIN_PRIVILEGE</td>
<td></td>
<td>没有管理员权限</td>
<td></td>
</tr>
<tr>
<td>ERR_NO_PRIVILEGE</td>
<td></td>
<td>没有权限</td>
<td></td>
</tr>
<tr>
<td>ERR_NO_SCREEN_SHARE</td>
<td></td>
<td>当前没有屏幕共享</td>
<td></td>
</tr>
<tr>
<td>ERR_RECVING_SCREEN_SHARE</td>
<td></td>
<td>当前正在接收屏幕共享</td>
<td></td>
</tr>
<tr>
<td>ERR_SERVER_ERROR</td>
<td></td>
<td>服务内部错误</td>
<td></td>
</tr>
<tr>
<td>ERR_FAIL</td>
<td></td>
<td>操作失败</td>
<td></td>
</tr>
</tbody>
</table>
<p><br data-tomark-pass=""><br>
<br data-tomark-pass=""></p>
<h3 id="-386">参数</h3>
<h2 id="roomuserinfo0a3ca20id3droomuserinfo53323e203ca3e">RoomUserInfo
<a id=RoomUserInfo5332> </a></h2>
<p></p>
<h3 id="-387">基本信息</h3>


<p><strong>接口描述：</strong></p>
<pre><code>struct RoomUserInfo
{
    S_BYTE			type = 0;				//用户类型,注册或非注册0 非注册， 1 注册
    S_BYTE			level = 0;				//用户级别
    S_BYTE			is_offline = 0;&nbsp; 			//是否离线
    S_UINT32			id = 0;					//ID

    int				terminal = 0;				//终端类型
    FString			username;				//username
    FString			role;					//角色信息

    FString			ip_address;				//ip
    FString			dept_id;				//部门id
    FString			node_id;				//登录节点

    struct State
    {
        S_BYTE			presenter;			&nbsp;&nbsp;&nbsp; 	//主讲状态presenter
        S_BYTE			data_sharer;				//共享人状态
        S_BYTE			phone_invite;				//电话邀请权限 0，无权限，1，已授权。
        S_BYTE			out_mute;				//静音状态
        S_BYTE			group_meeting;				//分组会议状态
        S_BYTE			super_manager;				//初始管理员
        S_BYTE			manager = 0;				//管理员状态
        S_BYTE			speaker_state;				//扬声器状态
        S_BYTE			local_record;				//本地录制状态
    };
    State			state;					//状态信息


    struct MediaShare							//媒体共享信息
    {
			S_BYTE			state;					//状态
			S_BYTE			is_restore;				//恢复状态（因为state==DONE 的时候可能是开始，和恢复）
			S_BYTE			audio_channel;				//音频通道
			S_BYTE			video_channel;				//视频通道
    };
	MediaShare			media_share;			//媒体共享信息

    struct AppShare							//屏幕共享信息
    {
			S_BYTE			state;					//状态
			S_BYTE			audio_channel;				//共享音频
    };
    AppShare		app_share;

    struct Contact							//联系信息
    {
        S_BYTE			sex;					//性别
        FString			nickname;				//昵称
        FString			telphone;				//电话
    };

    Contact			contact;				//联系信息
    AudioChannel	audio_channel;						//音频数据
    VideoChannel	video_channels[6];					//视频数据
    S_INT32			cur_virtual_dev;				//当前虚拟视频设备
    S_INT32			default_video_dev;			//默认的摄像头设备ID
};
</code></pre>
<h3 id="-388">参数</h3>

            <footer class="m-footer">
              <p>Build by <a href="https://ymfe.org/">YMFE</a>.</p>
            </footer>
          </div>
        </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped src="./index.css"></style>
